/* ============================================
   TFK Flower — theme.js
   Cart drawer (Ajax), customizer, scroll nav.
   ============================================ */

(function () {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ── Money formatter (uses Shopify routes if available) ──
  const formatMoney = (cents) => {
    const v = (cents / 100).toFixed(0);
    return "HKD " + Number(v).toLocaleString();
  };

  // ── Sticky nav scrolled state ──
  const nav = $(".nav");
  const onScroll = () => {
    if (!nav) return;
    nav.classList.toggle("scrolled", window.scrollY > 80);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // ── Toast utility (atelier slide-in feedback for ATC etc.) ──
  window.tfkToast = function tfkToast(msg, opts) {
    opts = opts || {};
    let host = document.querySelector('.tfk-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'tfk-toast-host';
      document.body.appendChild(host);
    }
    const t = document.createElement('div');
    t.className = 'tfk-toast' + (opts.error ? ' tfk-toast-error' : '');
    t.setAttribute('role', 'status');
    t.innerHTML = '<span class="tfk-toast-mark" aria-hidden="true">' + (opts.error ? '!' : '✓') + '</span><span class="tfk-toast-msg">' + msg + '</span>';
    host.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-visible'));
    setTimeout(() => {
      t.classList.remove('is-visible');
      setTimeout(() => t.remove(), 300);
    }, opts.duration || 2400);
  };

  // ── Cart drawer ──
  const drawer = $("[data-cart-drawer]");
  const openDrawer = () => {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("is-open", "open");
    document.body.classList.add("cart-open", "drawer-open");
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("is-open", "open");
    document.body.classList.remove("cart-open", "drawer-open");
  };
  $$("[data-cart-toggle]").forEach((b) => b.addEventListener("click", openDrawer));
  $$("[data-cart-close]").forEach((b)  => b.addEventListener("click", closeDrawer));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  // ════════════════════════════════════════════════════════════
  // β.2 · Customer info panel · capture + auto-fill checkout (2026-05-12)
  // β.3 · Checkout button hijack · build prefill URL with checkout[...] params
  // ════════════════════════════════════════════════════════════
  const TFK_INFO_KEY = 'tfk_customer_info_v1';
  const tfkLoadInfo = () => {
    try { return JSON.parse(localStorage.getItem(TFK_INFO_KEY) || '{}'); } catch (e) { return {}; }
  };
  const tfkSaveInfo = (info) => {
    try { localStorage.setItem(TFK_INFO_KEY, JSON.stringify(info)); } catch (e) {}
  };
  const tfkSyncInfoFromForm = () => {
    const info = {
      name:    document.querySelector('[data-cd-info-name]')?.value?.trim()    || '',
      email:   document.querySelector('[data-cd-info-email]')?.value?.trim()   || '',
      phone:   document.querySelector('[data-cd-info-phone]')?.value?.trim()   || '',
      address: document.querySelector('[data-cd-info-address]')?.value?.trim() || ''
    };
    return info;
  };
  const tfkApplyInfoToForm = (info) => {
    const el = (s) => document.querySelector(s);
    if (el('[data-cd-info-name]'))    el('[data-cd-info-name]').value    = info.name    || el('[data-cd-info-name]').value || '';
    if (el('[data-cd-info-email]'))   el('[data-cd-info-email]').value   = info.email   || el('[data-cd-info-email]').value || '';
    if (el('[data-cd-info-phone]'))   el('[data-cd-info-phone]').value   = info.phone   || el('[data-cd-info-phone]').value || '';
    if (el('[data-cd-info-address]')) el('[data-cd-info-address]').value = info.address || el('[data-cd-info-address]').value || '';
  };
  const tfkUpdateInfoStatus = () => {
    const info = tfkSyncInfoFromForm();
    const fields = ['name','email','phone','address'];
    const filled = fields.filter(k => info[k]).length;
    const status = document.querySelector('[data-cd-info-status]');
    /* Update top-level status badge */
    if (status) {
      status.classList.remove('cd-status-done','cd-status-warn');
      if (filled === 4) {
        status.textContent = '✓ 全部已填 · 可結帳';
        status.classList.add('cd-status-done');
      } else if (filled > 0) {
        status.textContent = `已自動填 ${filled}/4 · 仲差 ${4-filled} 項`;
        status.classList.add('cd-status-warn');
      } else {
        status.textContent = '⚠ 請填以便結帳';
        status.classList.add('cd-status-warn');
      }
    }
    /* Per-field badge */
    fields.forEach(k => {
      const badge = document.querySelector('[data-cd-field-status="' + k + '"]');
      if (!badge) return;
      if (info[k]) {
        badge.textContent = '✓ 已填';
        badge.classList.remove('is-empty');
        badge.classList.add('is-filled');
      } else {
        badge.textContent = '⚠ 未填';
        badge.classList.remove('is-filled');
        badge.classList.add('is-empty');
      }
    });
  };
  // β.2 · Pre-fill 送貨地址 + 電話 from cart line items
  // 2026-05-19 expanded · funeral (venue/floor/hall) + bouquet/basket (Delivery Zone/Sender Phone)
  const tfkPrefillFromCart = async () => {
    try {
      const r = await fetch('/cart.js');
      if (!r.ok) return;
      const cart = await r.json();
      const info = tfkLoadInfo();
      let venue = '', floor = '', room = '', zone = '', phone = '';
      for (const item of cart.items) {
        if (!item.properties) continue;
        for (const [k, v] of Object.entries(item.properties)) {
          if (k.startsWith('_')) continue; /* hidden props skip */
          if (!v) continue;
          /* Funeral venue address (殯儀館 / 教堂 / 火葬場) */
          if (k.includes('送貨地點') || k.includes('Delivery Location') || k.includes('venue')) venue = v;
          if (k.includes('樓層') || k.includes('Floor')) floor = v;
          if (k.includes('禮堂') || k.includes('Hall')) room = v;
          /* Bouquet / basket delivery zone (recipient address area) */
          if (k.includes('送貨地區') || k.includes('Delivery Zone')) zone = v;
          /* Customer phone · funeral 用 訂花人電話 · bouquet/basket 用 送花人電話 */
          if (k.includes('訂花人電話') || k.includes('Customer Phone')
              || k.includes('送花人電話') || k.includes("Sender's Phone") || k.includes('Sender Phone')) phone = v;
        }
      }
      /* Funeral priority · venue + floor + room */
      if (venue && !info.address) {
        info.address = [venue, floor, room].filter(Boolean).join(' ');
      }
      /* Fallback to bouquet/basket zone if no funeral address */
      if (!info.address && zone) {
        info.address = zone;
      }
      if (phone && !info.phone) info.phone = phone;
      tfkApplyInfoToForm(info);
      tfkUpdateInfoStatus();
      tfkSaveInfo(info);
    } catch (e) { /* silent fail */ }
  };
  // Wire form input listeners · save on each input
  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!t.matches('[data-cd-info-name],[data-cd-info-email],[data-cd-info-phone],[data-cd-info-address]')) return;
    const info = tfkSyncInfoFromForm();
    tfkSaveInfo(info);
    tfkUpdateInfoStatus();
  });
  // On cart drawer open: load info from storage + prefill from cart
  const _openDrawerOrig = openDrawer;
  window.tfkOpenDrawerWithPrefill = function(){
    _openDrawerOrig();
    tfkApplyInfoToForm(tfkLoadInfo());
    tfkUpdateInfoStatus();
    tfkPrefillFromCart();
  };
  // Override openDrawer · auto-prefill every time drawer opens
  $$("[data-cart-toggle]").forEach((b) => {
    b.removeEventListener("click", openDrawer);
    b.addEventListener("click", () => {
      window.tfkOpenDrawerWithPrefill();
      /* β · Always refresh cart body on open · 防止 stale empty state */
      refreshCart();
      /* β · Request desktop notification permission on first interaction */
      if (!tfkIsMobile()) tfkRequestNotificationPermission();
    });
  });
  // Also prefill on initial load if drawer already open
  document.addEventListener('DOMContentLoaded', () => {
    tfkApplyInfoToForm(tfkLoadInfo());
    tfkUpdateInfoStatus();
    tfkPrefillFromCart();
  });

  // β.3 · Checkout button URL hijack · append checkout[...] prefill params
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cd-checkout-btn]');
    if (!btn) return;
    e.preventDefault();
    const info = tfkSyncInfoFromForm();
    tfkSaveInfo(info);
    const base = btn.getAttribute('href') || '/checkout';
    const params = new URLSearchParams();
    if (info.email)   params.set('checkout[email]', info.email);
    if (info.name) {
      const parts = info.name.trim().split(/\s+/);
      const first = parts[0] || '';
      const last = parts.slice(1).join(' ') || '';
      if (first) params.set('checkout[shipping_address][first_name]', first);
      if (last)  params.set('checkout[shipping_address][last_name]', last);
      else if (first) params.set('checkout[shipping_address][last_name]', first); /* fallback if only 1 word · use same for both */
    }
    if (info.address) params.set('checkout[shipping_address][address1]', info.address);
    if (info.phone)   params.set('checkout[shipping_address][phone]', info.phone);
    /* HK default country */
    params.set('checkout[shipping_address][country]', 'Hong Kong SAR');
    params.set('checkout[shipping_address][city]', 'Hong Kong');
    const url = base + (base.includes('?') ? '&' : '?') + params.toString();
    window.location.href = url;
  });

  // ════════════════════════════════════════════════════════════
  // β.6 · Upsell options · checkbox state → cart attributes
  // β.7 · Free shipping bar · update based on cart total
  // ════════════════════════════════════════════════════════════
  // β.7 v2 · Countdown 5% off · funeral skip discount · sessionStorage timer (10 min)
  const TFK_COUNTDOWN_KEY = 'tfk_countdown_start_v1';
  const TFK_COUNTDOWN_MS = 10 * 60 * 1000;
  const TFK_DISCOUNT_CODE = 'TFK5OFF';
  const TFK_ALERT_THRESHOLD_MS = 2 * 60 * 1000; /* β · 最後 2 分鐘 alert */
  const TFK_ALERT_FIRED_KEY = 'tfk_countdown_alert_fired_v1';

  function tfkIsMobile(){
    return window.matchMedia('(pointer: coarse)').matches || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

  function tfkRequestNotificationPermission(){
    if (!('Notification' in window)) return;
    if (Notification.permission === 'default') {
      Notification.requestPermission().catch(() => {});
    }
  }

  /* β · Web Audio chime · cross-platform · 合成短促雙音「叮」(autoplay-friendly after user click cart) */
  function tfkPlayChime(){
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      const ctx = new Ctx();
      function tone(freq, startOffset, duration){
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.value = freq;
        const t = ctx.currentTime + startOffset;
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
        osc.start(t);
        osc.stop(t + duration + 0.02);
      }
      /* Two-tone "叮咚" · 880Hz then 1175Hz */
      tone(880, 0, 0.18);
      tone(1175, 0.16, 0.28);
      /* Close context after sound */
      setTimeout(() => { try { ctx.close(); } catch(e){} }, 800);
    } catch(e) { console.warn('TFK chime error', e); }
  }

  /* β · Visual flash · cart drawer countdown box 紅色 pulse 4 次 (~2 秒) */
  function tfkFlashCountdown(){
    const el = document.querySelector('[data-cd-countdown]');
    if (!el) return;
    el.classList.remove('cd-cd-flash');
    void el.offsetWidth; /* force reflow */
    el.classList.add('cd-cd-flash');
    setTimeout(() => el.classList.remove('cd-cd-flash'), 2400);
  }

  function tfkFire2MinAlert(){
    if (sessionStorage.getItem(TFK_ALERT_FIRED_KEY) === '1') return;
    sessionStorage.setItem(TFK_ALERT_FIRED_KEY, '1');
    try {
      /* ALL platforms · visual flash + chime sound */
      tfkFlashCountdown();
      tfkPlayChime();
      /* Android · vibrate as bonus */
      if (tfkIsMobile() && navigator.vibrate) {
        navigator.vibrate([200, 100, 200, 100, 400]);
      }
      /* Desktop · Web Notification as bonus (if permission granted) */
      if (!tfkIsMobile() && 'Notification' in window && Notification.permission === 'granted') {
        const notif = new Notification('⏰ TFK Flower · 限時優惠提示', {
          body: '你嘅 5% off 仲剩 2 分鐘 · 撳呢度返去結帳',
          icon: '/favicon.ico',
          tag: 'tfk-countdown',
          requireInteraction: false
        });
        notif.onclick = function(){
          window.focus();
          const drawer = document.querySelector('[data-cart-drawer]');
          if (drawer && !drawer.classList.contains('open')) {
            const toggle = document.querySelector('[data-cart-toggle]');
            if (toggle) toggle.click();
          }
          notif.close();
        };
      }
    } catch(e) { console.warn('TFK alert fired error', e); }
  }

  async function tfkUpdateCountdown(){
    const el = document.querySelector('[data-cd-countdown]');
    if (!el) return;
    const icon = el.querySelector('[data-cd-cd-icon]');
    const label = el.querySelector('[data-cd-cd-label]');
    const timer = el.querySelector('[data-cd-cd-timer]');
    const cta = el.querySelector('[data-cd-cd-cta]');
    const fill = el.querySelector('[data-cd-cd-fill]');

    let hasFuneral = false;
    let cartEmpty = false;
    try {
      const r = await fetch('/cart.js');
      if (r.ok) {
        const cart = await r.json();
        if (cart.item_count === 0) { cartEmpty = true; }
        hasFuneral = cart.items.some(it =>
          (it.product_type && /funeral|白事|帛事/i.test(it.product_type)) ||
          (it.product_title && /funeral|白事|帛事|花圈/i.test(it.product_title)) ||
          (it.properties && Object.keys(it.properties).some(k => k.includes('先人') || k.includes('輓聯') || k.includes('Deceased')))
        );
      }
    } catch(e) {}

    if (cartEmpty) {
      el.hidden = true;
      /* Cart empty · 自動 reset countdown · 客人重新揀有 fresh 10 分鐘 */
      sessionStorage.removeItem(TFK_COUNTDOWN_KEY);
      sessionStorage.removeItem(TFK_ALERT_FIRED_KEY); /* 重置 alert flag */
      const upsellEmpty = document.querySelector('[data-cd-upsell]');
      if (upsellEmpty) upsellEmpty.style.display = '';
      return;
    }
    el.hidden = false;
    el.classList.remove('is-expired','is-funeral','is-final60','is-final10');
    /* Reset upsell visibility (in case previously hidden by funeral cart) */
    const upsellShow = document.querySelector('[data-cd-upsell]');
    if (upsellShow && !hasFuneral) upsellShow.style.display = '';

    if (hasFuneral) {
      /* β revision 2 · Funeral cart · 完全唔顯示 countdown · 尊重先人 */
      el.hidden = true;
      el.style.cursor = '';
      el.onclick = null;
      /* 同時隱藏 upsell 同 trust 嘅 promo 部分 */
      const upsell = document.querySelector('[data-cd-upsell]');
      if (upsell) upsell.style.display = 'none';
      return;
    }

    let start = sessionStorage.getItem(TFK_COUNTDOWN_KEY);
    if (!start) {
      start = Date.now();
      sessionStorage.setItem(TFK_COUNTDOWN_KEY, start);
    }
    start = parseInt(start);
    const remain = Math.max(0, start + TFK_COUNTDOWN_MS - Date.now());

    if (remain === 0) {
      el.classList.add('is-expired');
      icon.textContent = '⏱';
      if (label) label.textContent = '優惠已完結';
      if (timer) timer.textContent = '';
      if (cta) cta.textContent = '';
      if (fill) fill.style.width = '0%';
      /* 唔再 clickable · 唔導向 WhatsApp */
      el.style.cursor = '';
      el.onclick = null;
      return;
    }

    /* Time states · final60 · final10 */
    if (remain <= 10000) el.classList.add('is-final10');
    if (remain <= 60000) el.classList.add('is-final60');

    /* β · 最後 2 分鐘 trigger mobile vibrate / desktop notification (once) */
    if (remain <= TFK_ALERT_THRESHOLD_MS && remain > 0) {
      tfkFire2MinAlert();
    }

    const min = Math.floor(remain / 60000);
    const sec = Math.floor((remain % 60000) / 1000);
    const mmss = String(min).padStart(2,'0') + ':' + String(sec).padStart(2,'0');
    const pct = (remain / TFK_COUNTDOWN_MS) * 100;

    icon.textContent = remain <= 60000 ? '⚠' : '🔥';
    if (label) label.textContent = remain <= 60000 ? '即將結束 · 限時自動 -5%' : '限時內結帳自動 -5%';
    if (timer) timer.textContent = mmss;
    if (cta) cta.textContent = '後恢復原價';
    if (fill) fill.style.width = pct + '%';
    el.style.cursor = '';
    el.onclick = null;
  }

  // Inject discount code into checkout URL on click (only if active countdown)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cd-checkout-btn]');
    if (!btn) return;
    const start = parseInt(sessionStorage.getItem(TFK_COUNTDOWN_KEY) || '0');
    if (!start) return;
    const remain = Math.max(0, start + TFK_COUNTDOWN_MS - Date.now());
    if (remain <= 0) return;
    const href = btn.getAttribute('href') || '/checkout';
    if (href.includes('discount=')) return;
    btn.setAttribute('href', href + (href.includes('?') ? '&' : '?') + 'discount=' + TFK_DISCOUNT_CODE);
  }, true);

  async function tfkUpdateUpsellAttrs(){
    const inputs = document.querySelectorAll('[data-cd-upsell-input]');
    const selected = [];
    inputs.forEach(inp => { if (inp.checked) selected.push(inp.dataset.key + ' (+$' + inp.dataset.price + ')'); });
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({attributes: {'升級加購 Upsell': selected.length ? selected.join(' · ') : ''}})
      });
    } catch(e) {}
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-cd-upsell-input]')) {
      tfkUpdateUpsellAttrs();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    tfkUpdateCountdown();
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) {
      setTimeout(tfkUpdateCountdown, 150);
    }
  });
  // β.7 v2 · Tick every second when drawer open
  setInterval(() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && drawer.classList.contains('open')) tfkUpdateCountdown();
  }, 1000);

  // ════════════════════════════════════════════════════════════
  // β.5 · Delivery badge · auto-update based on HKT + funeral context
  // ════════════════════════════════════════════════════════════
  async function tfkUpdateDeliveryBadge(){
    const badge = document.querySelector('[data-cd-delivery]');
    if (!badge) return;
    const icon = badge.querySelector('[data-cd-db-icon]');
    const title = badge.querySelector('[data-cd-db-title]');
    const sub = badge.querySelector('[data-cd-db-sub]');

    let hasFuneral = false;
    try {
      const r = await fetch('/cart.js');
      if (r.ok) {
        const cart = await r.json();
        if (cart.item_count === 0) { badge.hidden = true; return; }
        hasFuneral = cart.items.some(it =>
          (it.product_type && /funeral|白事|帛事/i.test(it.product_type)) ||
          (it.product_title && /funeral|白事|帛事|花圈|花籃/i.test(it.product_title)) ||
          (it.properties && Object.keys(it.properties).some(k => k.includes('先人') || k.includes('輓聯') || k.includes('venue') || k.includes('Deceased')))
        );
      }
    } catch(e) {}

    badge.hidden = false;
    badge.classList.remove('is-sameday','is-nextday','is-urgent');

    /* β revision · Funeral cart 唔再 show 特別急件 badge · 改回 standard delivery badge */
    /* (intentionally removed) */

    const now = new Date();
    const hk = new Date(now.toLocaleString('en-US',{timeZone:'Asia/Hong_Kong'}));
    const h = hk.getHours();

    if (h >= 10 && h < 14) {
      badge.classList.add('is-sameday');
      icon.textContent = '🚚';
      title.textContent = '即日送達 ✓';
      sub.textContent = '14:00 前下單 · 今晚 18:00-21:00 抵達';
    } else if (h >= 14 && h < 21) {
      badge.classList.add('is-nextday');
      icon.textContent = '🌅';
      title.textContent = '翌日 09:00-12:00 送達';
      sub.textContent = '今日仍可下單 · 明早第一輪派送';
    } else {
      badge.classList.add('is-nextday');
      icon.textContent = '🌅';
      title.textContent = '翌日 09:00-12:00 送達';
      sub.textContent = '我哋會喺明早第一輪派送送達';
    }
  }
  document.addEventListener('DOMContentLoaded', tfkUpdateDeliveryBadge);
  setInterval(tfkUpdateDeliveryBadge, 60000);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) {
      setTimeout(tfkUpdateDeliveryBadge, 100);
    }
  });

  // ── Refresh cart drawer + count from Shopify Cart API ──
  function tfkEscapeHtml(s){
    return String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]);
  }
  function tfkRenderCartBody(cart){
    /* β revision · target [data-cart-items] sub-container · 保留 delivery badge / upsell / countdown / trust */
    const body = document.querySelector('[data-cart-items]') || document.querySelector('[data-cart-body]');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cd-empty"><p class="cd-empty-en">Your bag is quiet.</p><p class="cd-empty-zh">購物袋目前是空的。</p><a href="/collections/all" class="cd-empty-link">Browse atelier · 逛一下 →</a></div>';
      return;
    }
    let html = '';
    cart.items.forEach(item => {
      const isSurcharge = item.product_type === 'Surcharge' || (item.product_handle || item.handle || '') === 'delivery-surcharge';
      const imgUrl = item.featured_image?.url || item.image || '';
      const props = item.properties || {};
      let propsHtml = '';
      Object.entries(props).forEach(([k, v]) => {
        if (!v || k.startsWith('_') || k === '') return;
        const isUrl = /^https?:\/\//.test(String(v));
        if (isUrl) {
          propsHtml += '<li class="cd-line-prop"><span class="cd-line-prop-key">'+tfkEscapeHtml(k)+'</span><span class="cd-line-prop-sep">·</span><a class="cd-line-prop-val" href="'+tfkEscapeHtml(v)+'" target="_blank" rel="noopener">View link</a></li>';
        } else {
          propsHtml += '<li class="cd-line-prop"><span class="cd-line-prop-key">'+tfkEscapeHtml(k)+'</span><span class="cd-line-prop-sep">·</span><span class="cd-line-prop-val">'+tfkEscapeHtml(v).replace(/\n/g,'<br>')+'</span></li>';
        }
      });
      const variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cd-line-variant">'+tfkEscapeHtml(item.variant_title)+'</div>' : '';
      const qtyBlock = isSurcharge
        ? '<span class="cd-line-qty-fixed">× <span class="num">1</span></span>'
        : '<div class="cd-qty"><button type="button" class="cd-qty-btn" data-cart-qty="-1" data-key="'+item.key+'" aria-label="Decrease">−</button><span class="cd-qty-num num">'+item.quantity+'</span><button type="button" class="cd-qty-btn" data-cart-qty="1" data-key="'+item.key+'" aria-label="Increase">+</button></div>';
      const imgBlock = isSurcharge
        ? '<span class="cd-surcharge-badge" aria-hidden="true">+</span>'
        : (imgUrl ? '<img src="'+tfkEscapeHtml(imgUrl)+'" alt="'+tfkEscapeHtml(item.product_title)+'" class="cd-line-photo" loading="lazy">' : '');
      const priceFormatted = formatMoney(item.final_line_price);

      html += '<article class="cd-line'+(isSurcharge?' cd-line-surcharge':'')+'" data-cart-item data-key="'+item.key+'">'
            + '<div class="cd-line-img">'+imgBlock+'</div>'
            + '<div class="cd-line-meta">'
            + '<a href="'+tfkEscapeHtml(item.url)+'" class="cd-line-title">'+tfkEscapeHtml(item.product_title)+'</a>'
            + variantTitle
            + (propsHtml ? '<ul class="cd-line-props">'+propsHtml+'</ul>' : '')
            + '<div class="cd-line-foot">' + qtyBlock + '<span class="cd-line-price num">'+priceFormatted+'</span></div>'
            + (isSurcharge ? '' : '<button type="button" class="cd-line-remove" data-cart-remove data-key="'+item.key+'" aria-label="移除呢件產品"><span class="cd-line-remove-x" aria-hidden="true">×</span><span class="cd-line-remove-text">移除</span></button>')
            + '</div></article>';
    });
    body.innerHTML = html;
  }
  function tfkRenderCartFoot(cart){
    /* Show/hide foot based on item count · works on initial render + dynamic add */
    const foot = document.querySelector('[data-cd-foot], .cd-foot');
    if (foot) foot.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }
  const refreshCart = async () => {
    try {
      const res = await fetch("/cart.js", { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      const cart = await res.json();
      $$("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle("has", cart.item_count > 0);
      });
      tfkRenderCartBody(cart);
      tfkRenderCartFoot(cart);
      $$("[data-cart-subtotal], [data-cart-total]").forEach((el) => el.textContent = formatMoney(cart.total_price));
    } catch (e) {
      console.warn("Cart refresh failed", e);
    }
  };

  // ── Hijack any add-to-cart form to use Ajax ──
  // TFK Phase γ · 2026-05-13 · 加埋 delivery picker state · surcharge variant · cart attribute
  const TFK_SURCHARGE_VIDS = ['53459121438904','53459121471672','53459121504440','53459063177400','53459063210168'];
  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const fd = new FormData(form);
    // ── Read delivery picker state ──
    const picker = document.querySelector('[data-tfk-delivery-picker]');
    let deliveryMode = '', deliveryDetail = '', surchargeVariant = '', surchargePrice = '0';
    if (picker) {
      const im = picker.querySelector('[data-tfk-prop-mode]');
      const id = picker.querySelector('[data-tfk-prop-detail]');
      const iv = picker.querySelector('[data-tfk-surcharge-variant]');
      const ip = picker.querySelector('[data-tfk-surcharge-price]');
      deliveryMode = (im && im.value) || '';
      deliveryDetail = (id && id.value) || '';
      surchargeVariant = (iv && iv.value) || '';
      surchargePrice = (ip && ip.value) || '0';
      if (deliveryMode) fd.append('properties[派送模式]', deliveryMode);
      if (deliveryDetail) fd.append('properties[派送詳情]', deliveryDetail);
      // TFK Bug 1 fix · 2026-05-18 · capture delivery date as line item properties
      const idDate = picker.querySelector('[data-tfk-prop-date]');
      const idDateIso = picker.querySelector('[data-tfk-prop-date-iso]');
      const deliveryDate = (idDate && idDate.value) || '';
      const deliveryDateIso = (idDateIso && idDateIso.value) || '';
      if (deliveryDate) fd.append('properties[送貨日期 Delivery Date]', deliveryDate);
      if (deliveryDateIso) fd.append('properties[送貨日期 ISO]', deliveryDateIso);
    }
    try {
      const res = await fetch("/cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json" } });
      if (!res.ok) throw new Error(await res.text());
      // ── Reconcile surcharge variant (remove old · add new if applicable) ──
      try {
        const cRes = await fetch('/cart.js', { cache: 'no-store' });
        const cart = await cRes.json();
        const stale = (cart.items || []).filter(i => TFK_SURCHARGE_VIDS.includes(String(i.variant_id)));
        for (const it of stale) {
          await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: it.key, quantity: 0 }) });
        }
      } catch(_) {}
      if (surchargeVariant) {
        try {
          await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ items: [{ id: Number(surchargeVariant), quantity: 1, properties: { '附加於': '本訂單 · ' + (deliveryMode || '配送升級') } }] }) });
        } catch(_) {}
      }
      // ── Sync cart attributes ──
      if (deliveryMode) {
        try {
          await fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ attributes: { '派送模式 Delivery Mode': deliveryMode, '派送詳情 Delivery Detail': deliveryDetail } }) });
        } catch(_) {}
      }
      await refreshCart();
      /* β revision · Mobile add-to-cart visibility · toast + cart count pulse */
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      if (isMobile) {
        if (window.tfkToast) {
          window.tfkToast('✓ 已加入購物袋 · 右上角查看', { duration: 2200 });
        } else {
          /* fallback toast · self-contained */
          const t = document.createElement('div');
          t.textContent = '✓ 已加入購物袋 · 右上角查看';
          t.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%);background:#32261E;color:#fff;padding:12px 18px;border-radius:24px;font-size:14px;z-index:9994;box-shadow:0 4px 14px rgba(0,0,0,.22);animation:tfkToastSlide .2s ease both';
          document.body.appendChild(t);
          setTimeout(() => { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; }, 2000);
          setTimeout(() => t.remove(), 2400);
        }
      }
      /* Cart count badge pulse */
      $$('[data-cart-count]').forEach(el => {
        el.classList.remove('tfk-cart-pulse');
        void el.offsetWidth;
        el.classList.add('tfk-cart-pulse');
      });
    } catch (err) {
      console.error(err);
      window.tfkToast ? window.tfkToast('未能加入購物袋，請重試', { error: true }) : alert("Sorry, this item couldn't be added.");
    }
  });

  // β revision · Clear all cart items handler · 同時 reset countdown
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cd-clear-all]');
    if (!btn) return;
    e.preventDefault();
    if (!confirm('確定清空購物車？已加產品會全部移除 · 同時會 reset 5% off 倒數，俾你重新揀 10 分鐘。')) return;
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      sessionStorage.removeItem(TFK_COUNTDOWN_KEY);
      window.location.reload();
    } catch (err) {
      console.error('Clear cart failed', err);
      alert('清空失敗，請重試');
    }
  });

  // ── Cart line qty + remove ──
  document.addEventListener("click", async (e) => {
    const qtyBtn = e.target.closest("[data-cart-qty]");
    const rmBtn  = e.target.closest("[data-cart-remove]");
    if (!qtyBtn && !rmBtn) return;
    e.preventDefault();
    const key = (qtyBtn || rmBtn).dataset.key;
    const item = $(`.cart-item[data-key="${CSS.escape(key)}"]`);
    let qty;
    if (rmBtn) {
      qty = 0;
    } else {
      const cur = parseInt(item?.querySelector(".qty-row span")?.textContent || "1", 10);
      qty = Math.max(0, cur + parseInt(qtyBtn.dataset.cartQty, 10));
    }
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      // Reload to repaint drawer (simplest reliable approach)
      window.location.reload();
    } catch (err) { console.error(err); }
  });

  // ── Customizer ──
  const cz = $(".customizer");
  if (cz) {
    const labelSize    = $("[data-cz-label-size]", cz);
    const labelPalette = $("[data-cz-label-palette]", cz);
    const variantInput = $("[data-cz-variant-id]", cz);
    const totalEl      = $("[data-cz-total]", cz);
    const propPalette  = $("[data-cz-prop-palette]", cz);
    const propWrap     = $("[data-cz-prop-wrap]", cz);
    const msgEl        = $("[data-cz-msg]", cz);
    const msgCountEl   = $("[data-cz-msg-count]", cz);
    const preview      = $("#cz-preview", cz);

    const updateTotal = () => {
      const variantBtn = $("[data-cz-variant].active", cz);
      const wrapBtn    = $("[data-cz-wrap].active", cz);
      const variantPrice = variantBtn ? parseInt(variantBtn.dataset.variantPrice, 10) : 0;
      const wrapAdd      = wrapBtn ? parseInt(wrapBtn.dataset.add || "0", 10) : 0;
      // wrapAdd is in HKD whole dollars (informational only — selling price comes from variant).
      const cents = variantPrice + wrapAdd * 100;
      if (totalEl) totalEl.textContent = formatMoney(cents);
    };

    // Size variant
    $$("[data-cz-variant]", cz).forEach((btn) => {
      btn.addEventListener("click", () => {
        $$("[data-cz-variant]", cz).forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (labelSize) labelSize.textContent = btn.dataset.variantTitle;
        const sel = btn.closest(".opt-group").querySelector('[data-cz-selected="size"]');
        if (sel) sel.textContent = btn.dataset.variantTitle;
        updateTotal();
      });
    });

    // Palette
    $$("[data-cz-palette]", cz).forEach((btn) => {
      btn.addEventListener("click", () => {
        $$("[data-cz-palette]", cz).forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        const name = btn.dataset.name;
        const hex  = btn.dataset.hex;
        if (labelPalette) labelPalette.textContent = name.split(" · ")[0];
        if (preview) preview.style.background = hex;
        if (propPalette) propPalette.value = name;
        const sel = btn.closest(".opt-group").querySelector('[data-cz-selected="palette"]');
        if (sel) sel.textContent = name.split(" · ")[0];
      });
    });

    // Wrap
    $$("[data-cz-wrap]", cz).forEach((btn) => {
      btn.addEventListener("click", () => {
        $$("[data-cz-wrap]", cz).forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        if (propWrap) propWrap.value = btn.dataset.name;
        const sel = btn.closest(".opt-group").querySelector('[data-cz-selected="wrap"]');
        if (sel) sel.textContent = btn.dataset.name;
        updateTotal();
      });
    });

    // Message char count
    if (msgEl && msgCountEl) {
      msgEl.addEventListener("input", () => {
        msgCountEl.textContent = `${msgEl.value.length}/120`;
      });
    }

    updateTotal();
  }

  // ── Favourite toggle (local only — replace with metafield API if needed) ──
  document.addEventListener("click", (e) => {
    const fav = e.target.closest("[data-fav-toggle]");
    if (!fav) return;
    e.preventDefault();
    fav.classList.toggle("on");
  });

  // ── Locale toggle (placeholder — wire to /locale_url for real switching) ──
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-locale-toggle]");
    if (!t) return;
    e.preventDefault();
    const cur = document.documentElement.lang;
    const next = cur && cur.startsWith("zh") ? "en" : "zh-TW";
    // Real impl: window.location.href = `/${next}${window.location.pathname}`;
    document.cookie = `locale=${next};path=/;max-age=31536000`;
    window.location.reload();
  });
})();

/* ============================================================
   TFK Hotfix v16 — Bag button text replace + bounce on add
   ============================================================ */
(function() {
  function replaceBagText() {
    document.querySelectorAll('a, button').forEach(el => {
      const txt = (el.textContent || '').trim();
      if (txt === 'BAG' || txt === 'Bag' || txt === 'bag') {
        // Save count (if any) before replace
        const countEl = el.querySelector('.cart-count, [data-cart-count]');
        const count = countEl ? countEl.cloneNode(true) : null;
        // Replace text node only, preserve element children
        Array.from(el.childNodes).forEach(node => {
          if (node.nodeType === 3 && /BAG|Bag|bag/.test(node.textContent)) {
            node.textContent = '購物車';
          }
        });
        // If textContent was just "BAG" without child elements:
        if (!el.querySelector('*') && el.textContent.trim() === 'BAG') {
          el.textContent = '購物車';
        }
        el.classList.add('bag-toggle');
      }
    });
  }
  
  function triggerBounce() {
    document.querySelectorAll('.bag-toggle, .cart-toggle, [data-cart-toggle], .nav-cart').forEach(btn => {
      btn.classList.remove('bag-bounce');
      // Force reflow
      void btn.offsetWidth;
      btn.classList.add('bag-bounce');
      setTimeout(() => btn.classList.remove('bag-bounce'), 750);
    });
  }
  
  // Run text replace on DOMContentLoaded + after delays for SPA-like updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceBagText);
  } else {
    replaceBagText();
  }
  setTimeout(replaceBagText, 500);
  setTimeout(replaceBagText, 1500);
  
  // Listen for Shopify cart events (multiple naming conventions)
  ['cart:added', 'cart:updated', 'cart:refresh', 'product:added'].forEach(evt => {
    document.addEventListener(evt, triggerBounce);
  });
  
  // Intercept fetch for /cart/add.js (most themes use this)
  const origFetch = window.fetch;
  window.fetch = function() {
    const args = arguments;
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    return origFetch.apply(this, args).then(res => {
      if (url.includes('/cart/add') || url.includes('/cart/change')) {
        triggerBounce();
      }
      return res;
    });
  };
  
  // Also intercept XMLHttpRequest (older themes)
  const origXHRopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', () => {
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
        triggerBounce();
      }
    });
    return origXHRopen.apply(this, arguments);
  };
})();

/* =====================================================================
   Filter row · Glass Capsule sliding indicator positioner
   ===================================================================== */
(function(){
  /* β revision · cart pulse + toast slide CSS */
  if (!document.getElementById('tfk-fb-css')) {
    const s = document.createElement('style');
    s.id = 'tfk-fb-css';
    s.textContent = '@keyframes tfkToastSlide{from{transform:translate(-50%,10px);opacity:0}to{transform:translate(-50%,0);opacity:1}}@keyframes tfkCartPulse{0%{transform:scale(1)}30%{transform:scale(1.35);background:#8B6F47;color:#fff}100%{transform:scale(1)}}.tfk-cart-pulse{animation:tfkCartPulse .6s ease}';
    document.head.appendChild(s);
  }
  function position(){
    document.querySelectorAll('.filter-row').forEach(function(row){
      var ind = row.querySelector('.filter-indicator');
      var act = row.querySelector('.chip.active');
      if(!ind) return;
      if(!act){
        ind.style.opacity = '0';
        return;
      }
      var r = act.getBoundingClientRect();
      var cr = row.getBoundingClientRect();
      ind.style.left = (r.left - cr.left) + 'px';
      ind.style.width = r.width + 'px';
      ind.style.opacity = '1';
    });
  }
  function init(){
    position();
    // 多 tick 重新計（fonts/web fonts may shift width）
    setTimeout(position, 100);
    setTimeout(position, 400);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  var rt;
  window.addEventListener('resize', function(){
    clearTimeout(rt);
    rt = setTimeout(position, 150);
  });
  // Re-position when fonts load (FOUT-safe)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(position);
  }
})();

/* =====================================================================
   Filter row · Mobile scroll hint bounce
   Page load 後喺手機向右 scroll 一下再返，物理示意有得滑
   ===================================================================== */
(function(){
  function bounceHint(){
    if (window.innerWidth >= 769) return; // mobile only
    var rows = document.querySelectorAll('.filter-row');
    rows.forEach(function(row){
      // 只係 row 本身可以 scroll 先做 hint
      if (row.scrollWidth <= row.clientWidth + 4) return;
      row.classList.add('scroll-hinting');
      // 1.5s 後向右 scroll 一下
      setTimeout(function(){
        row.scrollLeft = 60;
        // 再回原位
        setTimeout(function(){
          row.scrollLeft = 0;
          // 清走 smooth class，讓用戶手動 swipe 即時 response
          setTimeout(function(){ row.classList.remove('scroll-hinting'); }, 700);
        }, 700);
      }, 1500);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bounceHint);
  } else {
    bounceHint();
  }
})();

/* =====================================================================
   Filter row · Marquee setup
   把 chip 包入 .filter-track + clone 一份，CSS translateX -50% 形成無縫 loop
   ===================================================================== */
(function(){
  function setupMarquee(){
    document.querySelectorAll('.filter-row').forEach(function(row){
      // 已經 setup 過跳過
      if (row.querySelector('.filter-track')) return;
      // 攞所有 chip（保留順序）
      var chips = Array.from(row.querySelectorAll('.chip, a.chip'));
      if (chips.length === 0) return;
      // 移除任何 indicator div（marquee 唔需要）
      var ind = row.querySelector('.filter-indicator');
      if (ind) ind.remove();
      // 建立 track wrapper
      var track = document.createElement('div');
      track.className = 'filter-track';
      // 移 chip 入 track
      chips.forEach(function(c){ track.appendChild(c); });
      // Clone chip 一次（aria-hidden + tabindex -1 比 a11y）
      chips.forEach(function(c){
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.tabIndex = -1;
        track.appendChild(clone);
      });
      // Append track 入 row
      row.appendChild(track);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMarquee);
  } else {
    setupMarquee();
  }
})();

/* =====================================================================
   PDP default template · swipe gallery 加 page indicator dots（desktop + mobile）
   ===================================================================== */
(function(){
  function setupGalleryDots(){
    var pdp = document.querySelector('.pdp-b.is-default-template');
    if (!pdp) return;
    var stack = pdp.querySelector('.gallery-stack');
    if (!stack) return;
    var items = stack.querySelectorAll('.gallery-stack-item');
    if (items.length <= 1) return;
    if (pdp.querySelector('.gallery-dots')) return; // already setup

    // Build dots
    var dots = document.createElement('div');
    dots.className = 'gallery-dots';
    items.forEach(function(_, i){
      var d = document.createElement('span');
      d.className = 'dot' + (i === 0 ? ' active' : '');
      d.dataset.i = i;
      dots.appendChild(d);
    });
    stack.parentElement.appendChild(dots);

    // Scroll listener: update active dot
    var ticking = false;
    function update(){
      var pos = stack.scrollLeft;
      var w = stack.clientWidth;
      var idx = Math.round(pos / w);
      idx = Math.max(0, Math.min(items.length - 1, idx));
      dots.querySelectorAll('.dot').forEach(function(d, i){
        d.classList.toggle('active', i === idx);
      });
      ticking = false;
    }
    stack.addEventListener('scroll', function(){
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    // Click dot to scroll to that image
    dots.addEventListener('click', function(e){
      var t = e.target;
      if (!t.classList.contains('dot')) return;
      var i = parseInt(t.dataset.i);
      stack.scrollTo({ left: i * stack.clientWidth, behavior: 'smooth' });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGalleryDots);
  } else {
    setupGalleryDots();
  }
})();

/* =====================================================================
   PDP default · 桌面 prev/next 箭頭（mobile 已有 dots）
   ===================================================================== */
(function(){
  function setupArrows(){
    var pdp = document.querySelector('.pdp-b.is-default-template');
    if (!pdp) return;
    var galleryWrap = pdp.querySelector('.gallery-b.gallery-stacked');
    var stack = pdp.querySelector('.gallery-stack');
    if (!galleryWrap || !stack) return;
    var items = stack.querySelectorAll('.gallery-stack-item');
    if (items.length <= 1) return;
    if (galleryWrap.querySelector('.gallery-arrow')) return; // already setup

    // Build prev/next
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gallery-arrow prev';
    prev.setAttribute('aria-label', 'Previous image');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gallery-arrow next';
    next.setAttribute('aria-label', 'Next image');

    galleryWrap.appendChild(prev);
    galleryWrap.appendChild(next);

    // Position helpers
    function getCurrentIndex(){
      return Math.round(stack.scrollLeft / stack.clientWidth);
    }
    function updateArrowState(){
      var i = getCurrentIndex();
      prev.classList.toggle('is-disabled', i <= 0);
      next.classList.toggle('is-disabled', i >= items.length - 1);
    }

    prev.addEventListener('click', function(){
      var i = getCurrentIndex() - 1;
      if (i < 0) return;
      stack.scrollTo({ left: i * stack.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function(){
      var i = getCurrentIndex() + 1;
      if (i >= items.length) return;
      stack.scrollTo({ left: i * stack.clientWidth, behavior: 'smooth' });
    });

    var ticking = false;
    stack.addEventListener('scroll', function(){
      if (!ticking) {
        requestAnimationFrame(function(){
          updateArrowState();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateArrowState();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupArrows);
  } else {
    setupArrows();
  }
})();

/* =====================================================================
   PDP related-grid · Mobile manual swipe（取消 auto loop）
   ===================================================================== */
(function(){
  // 用戶要求手動 swipe，唔做 auto-scroll · 但保留清理 .related-track 嘅工作
  // （之前 marquee JS 可能 clone 咗 cards · 確保依家剩番唯一 set，避免重複）
  function cleanup(){
    document.querySelectorAll('.related-grid').forEach(function(grid){
      var track = grid.querySelector('.related-track');
      if (!track) return;
      // 移除 aria-hidden 嘅 clone（保留 originals）
      var clones = track.querySelectorAll('.related-card[aria-hidden="true"]');
      clones.forEach(function(c){ c.parentNode.removeChild(c); });
      // 將 originals lift 出嚟，移走 track wrapper
      var originals = Array.from(track.children);
      originals.forEach(function(c){ grid.appendChild(c); });
      track.parentNode.removeChild(track);
      // 重置 inline style
      grid.style.transform = '';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }
})();

/* =====================================================================
   Mother's Day · Countdown timer
   ===================================================================== */
(function(){
  function pad(n){ return n<10 ? '0'+n : ''+n; }
  function tickAll(){
    document.querySelectorAll('[data-md-countdown]').forEach(function(el){
      var target = el.dataset.target;
      if (!target) return;
      var t = new Date(target).getTime();
      if (isNaN(t)) return;
      var now = Date.now();
      var diff = t - now;
      var dEl = el.querySelector('[data-d]');
      var hEl = el.querySelector('[data-h]');
      var mEl = el.querySelector('[data-m]');
      var sEl = el.querySelector('[data-s]');
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      // B 方案只用日數 · 但仍然兼容 4 格 (data-h/m/s)
      var dStr = String(d);  // 唔 pad，1 位 / 2 位都 OK
      var dPadded = pad(d);
      if (dEl) dEl.textContent = dStr;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      // B 方案專用 · 中文版
      var dZh = el.querySelector('[data-d-zh]');
      if (dZh) dZh.textContent = dStr;
    });
  }
  function start(){
    if (document.querySelectorAll('[data-md-countdown]').length === 0) return;
    tickAll();
    setInterval(tickAll, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* =====================================================================
   Announcement Bar · 倒數 days + dismiss with sessionStorage
   ===================================================================== */
(function(){
  function setup(){
    var bars = document.querySelectorAll('[data-ann-bar]');
    bars.forEach(function(bar){
      var key = bar.dataset.key || 'announcement';
      // 檢查 dismiss state
      try {
        if (sessionStorage.getItem('ann-dismissed-' + key) === '1') {
          bar.classList.add('is-hidden');
          return;
        }
      } catch(e) {}

      // Countdown
      var target = bar.dataset.target;
      var dEl = bar.querySelector('[data-d]');
      function updateDays(){
        if (!target || !dEl) return;
        var t = new Date(target).getTime();
        if (isNaN(t)) return;
        var diff = t - Date.now();
        if (diff <= 0) {
          dEl.textContent = '0';
          return;
        }
        var d = Math.floor(diff / 86400000);
        dEl.textContent = String(d);
      }
      updateDays();
      setInterval(updateDays, 60000);  // 每分鐘 update（日數變動極慢）

      // Dismiss
      var closeBtn = bar.querySelector('[data-ann-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(){
          bar.classList.add('is-hidden');
          try { sessionStorage.setItem('ann-dismissed-' + key, '1'); } catch(e) {}
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* =====================================================================
   2026-05-04 · Grand Opening template · 賀卡 LIVE preview · v2
   多選 chips max 2 · 1 或 2 個賀詞自動切換 layout · 去掉「來自」
   ===================================================================== */
(function(){
  function initGrandOpening(){
    const block = document.querySelector('.go-block');
    if(!block) return;

    const recipientInput = block.querySelector('[data-go-recipient]');
    const wishInput = block.querySelector('[data-go-wish-input]');
    const senderInput = block.querySelector('[data-go-sender]');
    const cardInput = block.querySelector('[data-go-card-input]');
    const chipsContainer = block.querySelector('[data-go-wish-chips]');
    const cardPicker = block.querySelector('[data-go-card-picker]');
    const allCards = block.querySelectorAll('.go-card');
    const wishesContainers = block.querySelectorAll('.wishes, .cert-wishes, .floral-wishes');

    const cardStyleNames = { '1': 'Atelier Centered', '2': 'Western Certificate', '3': 'Chinese Floral' };
    const MAX_WISHES = 2;
    const selectedWishes = []; // up to 2

    function refreshChipStates() {
      if(!chipsContainer) return;
      chipsContainer.querySelectorAll('.go-chip').forEach(c => {
        c.classList.toggle('selected', selectedWishes.indexOf(c.dataset.goWish) >= 0);
      });
      if(selectedWishes.length >= MAX_WISHES) {
        chipsContainer.setAttribute('data-max-reached', '1');
      } else {
        chipsContainer.removeAttribute('data-max-reached');
      }
    }

    function updateWishInputValue() {
      if(!wishInput) return;
      wishInput.value = selectedWishes.join(' · ');
    }

    function refreshPreview() {
      const recipient = (recipientInput && recipientInput.value.trim()) || '○○○ 餐廳';
      const sender = (senderInput && senderInput.value.trim()) || '王氏集團';
      const w1 = selectedWishes[0] || (wishInput && !selectedWishes.length ? (wishInput.value.split('·')[0] || '').trim() : '') || '鴻圖大展';
      const w2 = selectedWishes[1] || (wishInput && wishInput.value.split('·')[1] ? wishInput.value.split('·')[1].trim() : '');

      block.querySelectorAll('[data-go-preview-recipient]').forEach(el => el.textContent = recipient);
      block.querySelectorAll('[data-go-preview-sender]').forEach(el => el.textContent = sender);
      block.querySelectorAll('[data-go-preview-wish-1]').forEach(el => el.textContent = w1);
      block.querySelectorAll('[data-go-preview-wish-2]').forEach(el => el.textContent = w2);

      // Toggle has-two class for wish containers
      wishesContainers.forEach(c => c.classList.toggle('has-two', !!w2));
    }

    // Chip click · toggle, max 2
    if(chipsContainer) {
      chipsContainer.addEventListener('click', function(e) {
        const chip = e.target.closest('.go-chip');
        if(!chip) return;
        e.preventDefault();
        const w = chip.dataset.goWish;
        const idx = selectedWishes.indexOf(w);
        if(idx >= 0) {
          selectedWishes.splice(idx, 1);
        } else {
          if(selectedWishes.length >= MAX_WISHES) selectedWishes.shift();
          selectedWishes.push(w);
        }
        refreshChipStates();
        updateWishInputValue();
        refreshPreview();
      });
    }

    // Manual input (override chips)
    if(wishInput) {
      wishInput.addEventListener('input', function() {
        // Parse 「鴻圖大展 · 業務興隆」 format
        const parts = wishInput.value.split('·').map(s => s.trim()).filter(Boolean).slice(0, 2);
        selectedWishes.length = 0;
        parts.forEach(p => selectedWishes.push(p));
        refreshChipStates();
        refreshPreview();
      });
    }

    // Recipient + sender inputs
    [recipientInput, senderInput].forEach(inp => {
      if(inp) inp.addEventListener('input', refreshPreview);
    });

    // Card style picker
    if(cardPicker) {
      cardPicker.addEventListener('click', function(e) {
        const thumb = e.target.closest('.go-card-thumb');
        if(!thumb) return;
        e.preventDefault();
        const id = thumb.dataset.goCard;
        cardPicker.querySelectorAll('.go-card-thumb').forEach(t => t.classList.toggle('active', t === thumb));
        allCards.forEach(c => c.classList.toggle('is-visible', c.dataset.goCardId === id));
        if(cardInput) cardInput.value = cardStyleNames[id] || id;
      });
    }

    // Initial paint
    refreshPreview();
    refreshChipStates();
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGrandOpening);
  } else {
    initGrandOpening();
  }
})();


/* Grand opening · main + thumbs gallery · click thumb 切換主圖 */
(function(){
  function initGoGallery(){
    document.querySelectorAll('[data-go-gallery]').forEach(function(g){
      var main = g.querySelector('[data-go-main] img');
      if(!main) return;
      var thumbs = g.querySelectorAll('[data-go-thumb]');
      thumbs.forEach(function(thumb){
        thumb.addEventListener('click', function(e){
          e.preventDefault();
          var src = thumb.getAttribute('data-go-img-src');
          if(src){
            main.src = src;
            // Update srcset to single hi-res to avoid browser refetch
            main.removeAttribute('srcset');
          }
          thumbs.forEach(function(t){ t.classList.toggle('active', t === thumb); });
        });
      });
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initGoGallery);
  } else {
    initGoGallery();
  }
})();
/* =====================================================================
   2026-05-07 · Funeral B2 Smart Form
   關係 dropdown → 自動 上款 sf · 多送花者 (prefix + 排行 + 名字)
   tier-progression filter · lineage filter · 性別+宗教 wish filter
   Live preview 含「率」字 + tier 字級對齊
   ===================================================================== */
(function(){
  function initFuneral(){
    const block = document.querySelector('.fn-block');
    if(!block) return;

    /* ─────── DOM cache ─────── */
    const relSelect       = block.querySelector('[data-fn-rel-select]');
    const decNameInput    = block.querySelector('[data-fn-deceased-name]');
    const religionChips   = block.querySelectorAll('[data-fn-religion-chip]');
    const religionInput   = block.querySelector('[data-fn-religion-input]');
    const wishChips       = block.querySelectorAll('[data-fn-wish-chip], .fn-wish-chip');
    const wishInput       = block.querySelector('[data-fn-wish-input]');
    const meaningBox      = block.querySelector('[data-fn-meaning-box]');
    const sendersWrap     = block.querySelector('[data-fn-senders]');
    const senderAddBtn    = block.querySelector('[data-fn-sender-add]');
    const suffixSelect    = block.querySelector('[data-fn-suffix-select]');
    const suffixInput     = block.querySelector('[data-fn-suffix-input]');
    const senderEncodedInp= block.querySelector('[data-fn-sender-encoded]');
    const previewTop      = block.querySelector('[data-fn-preview-top]');
    const previewMid      = block.querySelector('[data-fn-preview-mid]');
    const previewBot      = block.querySelector('[data-fn-preview-bot]');
    const previewSuffix   = block.querySelector('[data-fn-preview-suffix]');

    /* β.1 v2 · Per-line dirty flag · 客人改過嘅 preview line 鎖住 · 其餘繼續 auto-update */
    const resetBtn        = block.querySelector('[data-fn-reset-btn]');
    const manualFlag      = block.querySelector('[data-fn-manual-flag]');
    const pbTopInput      = block.querySelector('[data-fn-pb-top-input]');
    const pbBotInput      = block.querySelector('[data-fn-pb-bot-input]');
    const dirtyMap = new WeakMap();
    const editables = [previewTop, previewMid, previewBot, previewSuffix].filter(Boolean);

    function isDirty(el){ return el && dirtyMap.get(el) === true; }
    function markDirty(el){ if (el) dirtyMap.set(el, true); }
    function clearAllDirty(){ editables.forEach(el => dirtyMap.set(el, false)); }
    function anyDirty(){ return editables.some(el => dirtyMap.get(el) === true); }

    function syncPreviewToHidden(){
      if (pbTopInput && previewTop) pbTopInput.value = previewTop.textContent.trim();
      if (pbBotInput && previewBot) pbBotInput.value = previewBot.textContent.trim();
      if (wishInput && previewMid && isDirty(previewMid)) wishInput.value = previewMid.textContent.trim();
      if (suffixInput && previewSuffix && isDirty(previewSuffix)) suffixInput.value = previewSuffix.textContent.trim();
      if (senderEncodedInp && previewBot && isDirty(previewBot)) senderEncodedInp.value = previewBot.textContent.trim();
      if (manualFlag) manualFlag.value = anyDirty() ? '是 Yes · 客人手動編輯' : '';
      if (resetBtn) resetBtn.hidden = !anyDirty();
    }

    function resetToAuto(){
      clearAllDirty();
      if (typeof updatePreview === 'function') updatePreview();
      syncPreviewToHidden();
    }

    if (resetBtn) resetBtn.addEventListener('click', resetToAuto);


    /* ─────── Maps ─────── */
    const REL = {
      father:           {pf:'父親大人',sf:'冥鑒',spf:'孝子',ss:'泣叩'},
      mother:           {pf:'母親大人',sf:'靈鑒',spf:'孝女',ss:'泣叩'},
      husband:          {pf:'夫君',sf:'千古',spf:'妻',ss:'哀輓'},
      wife:             {pf:'賢妻',sf:'靈右',spf:'夫',ss:'哀輓'},
      'brother-elder':  {pf:'胞兄',sf:'千古',spf:'胞弟',ss:'敬輓'},
      'brother-younger':{pf:'胞弟',sf:'千古',spf:'胞兄',ss:'敬輓'},
      'sister-elder':   {pf:'胞姊',sf:'靈右',spf:'胞妹',ss:'敬輓'},
      'sister-younger': {pf:'胞妹',sf:'靈右',spf:'胞姊',ss:'敬輓'},
      'father-in-law-h':{pf:'家翁大人',sf:'冥鑒',spf:'孝媳',ss:'泣叩'},
      'mother-in-law-h':{pf:'家姑大人',sf:'靈鑒',spf:'孝媳',ss:'泣叩'},
      'father-in-law-w':{pf:'岳父大人',sf:'冥鑒',spf:'孝婿',ss:'泣叩'},
      'mother-in-law-w':{pf:'岳母大人',sf:'靈鑒',spf:'孝婿',ss:'泣叩'},
      'uncle-f-elder':  {pf:'伯父大人',sf:'冥鑒',spf:'姪',ss:'敬輓'},
      'uncle-f-younger':{pf:'叔父大人',sf:'冥鑒',spf:'姪',ss:'敬輓'},
      'aunt-uncle-f':   {pf:'伯娘大人',sf:'靈鑒',spf:'姪',ss:'敬輓'},
      'aunt-f':         {pf:'姑媽大人',sf:'靈鑒',spf:'姪',ss:'敬輓'},
      'uncle-aunt-f':   {pf:'姑丈大人',sf:'冥鑒',spf:'姪',ss:'敬輓'},
      'uncle-m':        {pf:'舅父大人',sf:'冥鑒',spf:'外甥',ss:'敬輓'},
      'aunt-by-uncle-m':{pf:'舅母大人',sf:'靈鑒',spf:'外甥',ss:'敬輓'},
      'aunt-m-elder':   {pf:'姨媽大人',sf:'靈鑒',spf:'外甥',ss:'敬輓'},
      'aunt-m-younger': {pf:'阿姨大人',sf:'靈鑒',spf:'外甥',ss:'敬輓'},
      'uncle-aunt-m':   {pf:'姨丈大人',sf:'冥鑒',spf:'外甥',ss:'敬輓'},
      'grandpa-paternal':{pf:'祖父大人',sf:'冥鑒',spf:'孝孫',ss:'泣叩'},
      'grandma-paternal':{pf:'祖母大人',sf:'靈鑒',spf:'孝孫',ss:'泣叩'},
      'grandpa-maternal':{pf:'外祖父大人',sf:'冥鑒',spf:'孝外孫',ss:'泣叩'},
      'grandma-maternal':{pf:'外祖母大人',sf:'靈鑒',spf:'孝外孫',ss:'泣叩'},
      'cousin-male':    {pf:'',sf:'先生 千古',spf:'表弟',ss:'敬輓'},
      'cousin-female':  {pf:'',sf:'女士 靈右',spf:'表妹',ss:'敬輓'},
      'brother-in-law': {pf:'',sf:'先生 千古',spf:'',ss:'敬輓'},
      'friend-m':       {pf:'',sf:'先生 千古',spf:'',ss:'敬輓'},
      'friend-f':       {pf:'',sf:'女士 靈右',spf:'',ss:'敬輓'},
      'colleague-m':    {pf:'',sf:'先生 千古',spf:'',ss:'敬輓'},
      'colleague-f':    {pf:'',sf:'女士 靈右',spf:'',ss:'敬輓'},
      'company':        {pf:'',sf:'先生／女士',spf:'',ss:'敬輓'},
      'church-m':       {pf:'',sf:'弟兄',spf:'',ss:'敬輓'},
      'church-f':       {pf:'',sf:'姊妹',spf:'',ss:'敬輓'},
      'junior-m':       {pf:'',sf:'千古',spf:'',ss:'痛輓'},
      'junior-f':       {pf:'',sf:'靈右',spf:'',ss:'痛輓'}
    };

    const VALID_SENDERS = {
      father: [{p:'孝子',t:1},{p:'孝女',t:1},{p:'孝媳',t:1},{p:'孝婿',t:1},{p:'孫男',t:2},{p:'孫女',t:2},{p:'外孫男',t:2},{p:'外孫女',t:2},{p:'曾孫男',t:3},{p:'曾孫女',t:3},{p:'玄孫男',t:4},{p:'玄孫女',t:4}],
      mother: [{p:'孝子',t:1},{p:'孝女',t:1},{p:'孝媳',t:1},{p:'孝婿',t:1},{p:'孫男',t:2},{p:'孫女',t:2},{p:'外孫男',t:2},{p:'外孫女',t:2},{p:'曾孫男',t:3},{p:'曾孫女',t:3},{p:'玄孫男',t:4},{p:'玄孫女',t:4}],
      husband: [{p:'妻',t:1},{p:'孝子',t:2},{p:'孝女',t:2},{p:'孝媳',t:2},{p:'孝婿',t:2},{p:'孫男',t:3},{p:'孫女',t:3},{p:'外孫男',t:3},{p:'外孫女',t:3}],
      wife: [{p:'夫',t:1},{p:'孝子',t:2},{p:'孝女',t:2},{p:'孝媳',t:2},{p:'孝婿',t:2},{p:'孫男',t:3},{p:'孫女',t:3},{p:'外孫男',t:3},{p:'外孫女',t:3}],
      'brother-elder':  [{p:'胞弟',t:1},{p:'胞妹',t:1},{p:'姪',t:2},{p:'姪女',t:2},{p:'外甥',t:2},{p:'外甥女',t:2}],
      'brother-younger':[{p:'胞兄',t:1},{p:'胞姊',t:1},{p:'姪',t:2},{p:'姪女',t:2},{p:'外甥',t:2},{p:'外甥女',t:2}],
      'sister-elder':   [{p:'胞弟',t:1},{p:'胞妹',t:1},{p:'姪',t:2},{p:'姪女',t:2},{p:'外甥',t:2},{p:'外甥女',t:2}],
      'sister-younger': [{p:'胞兄',t:1},{p:'胞姊',t:1},{p:'姪',t:2},{p:'姪女',t:2},{p:'外甥',t:2},{p:'外甥女',t:2}],
      'father-in-law-h':[{p:'孝媳',t:1},{p:'孝子',t:1},{p:'孫男',t:2},{p:'孫女',t:2},{p:'曾孫男',t:3},{p:'曾孫女',t:3}],
      'mother-in-law-h':[{p:'孝媳',t:1},{p:'孝子',t:1},{p:'孫男',t:2},{p:'孫女',t:2},{p:'曾孫男',t:3},{p:'曾孫女',t:3}],
      'father-in-law-w':[{p:'孝婿',t:1},{p:'孝女',t:1},{p:'孫男',t:2},{p:'孫女',t:2},{p:'曾孫男',t:3},{p:'曾孫女',t:3}],
      'mother-in-law-w':[{p:'孝婿',t:1},{p:'孝女',t:1},{p:'孫男',t:2},{p:'孫女',t:2},{p:'曾孫男',t:3},{p:'曾孫女',t:3}],
      'uncle-f-elder':  [{p:'姪',t:1},{p:'姪女',t:1},{p:'姪孫',t:2},{p:'姪孫女',t:2},{p:'姪曾孫',t:3},{p:'姪曾孫女',t:3}],
      'uncle-f-younger':[{p:'姪',t:1},{p:'姪女',t:1},{p:'姪孫',t:2},{p:'姪孫女',t:2},{p:'姪曾孫',t:3},{p:'姪曾孫女',t:3}],
      'aunt-uncle-f':   [{p:'姪',t:1},{p:'姪女',t:1},{p:'姪孫',t:2},{p:'姪孫女',t:2},{p:'姪曾孫',t:3},{p:'姪曾孫女',t:3}],
      'aunt-f':         [{p:'姪',t:1},{p:'姪女',t:1},{p:'姪孫',t:2},{p:'姪孫女',t:2},{p:'姪曾孫',t:3},{p:'姪曾孫女',t:3}],
      'uncle-aunt-f':   [{p:'姪',t:1},{p:'姪女',t:1},{p:'姪孫',t:2},{p:'姪孫女',t:2},{p:'姪曾孫',t:3},{p:'姪曾孫女',t:3}],
      'uncle-m':        [{p:'外甥',t:1},{p:'外甥女',t:1},{p:'外甥孫',t:2},{p:'外甥孫女',t:2}],
      'aunt-by-uncle-m':[{p:'外甥',t:1},{p:'外甥女',t:1},{p:'外甥孫',t:2},{p:'外甥孫女',t:2}],
      'aunt-m-elder':   [{p:'外甥',t:1},{p:'外甥女',t:1},{p:'外甥孫',t:2},{p:'外甥孫女',t:2}],
      'aunt-m-younger': [{p:'外甥',t:1},{p:'外甥女',t:1},{p:'外甥孫',t:2},{p:'外甥孫女',t:2}],
      'uncle-aunt-m':   [{p:'外甥',t:1},{p:'外甥女',t:1},{p:'外甥孫',t:2},{p:'外甥孫女',t:2}],
      'grandpa-paternal':[{p:'孝孫',t:1},{p:'孝孫女',t:1},{p:'曾孫男',t:2},{p:'曾孫女',t:2},{p:'玄孫男',t:3},{p:'玄孫女',t:3}],
      'grandma-paternal':[{p:'孝孫',t:1},{p:'孝孫女',t:1},{p:'曾孫男',t:2},{p:'曾孫女',t:2},{p:'玄孫男',t:3},{p:'玄孫女',t:3}],
      'grandpa-maternal':[{p:'孝外孫',t:1},{p:'孝外孫女',t:1},{p:'外曾孫男',t:2},{p:'外曾孫女',t:2}],
      'grandma-maternal':[{p:'孝外孫',t:1},{p:'孝外孫女',t:1},{p:'外曾孫男',t:2},{p:'外曾孫女',t:2}],
      'cousin-male':    [{p:'表弟',t:1},{p:'表妹',t:1},{p:'表姪',t:2},{p:'表姪女',t:2}],
      'cousin-female':  [{p:'表兄',t:1},{p:'表姊',t:1},{p:'表姪',t:2},{p:'表姪女',t:2}],
      'brother-in-law': [{p:'',t:1}],
      'friend-m':       [{p:'',t:1}],
      'friend-f':       [{p:'',t:1}],
      'colleague-m':    [{p:'',t:1}],
      'colleague-f':    [{p:'',t:1}],
      'company':        [{p:'',t:1}],
      'church-m':       [{p:'',t:1}],
      'church-f':       [{p:'',t:1}],
      'junior-m':       [{p:'',t:1}],
      'junior-f':       [{p:'',t:1}]
    };

    const TIER1_LINEAGE = {
      '胞兄':'paternal','胞弟':'paternal','胞姊':'maternal','胞妹':'maternal',
      '孝子':'paternal','孝男':'paternal','孝媳':'paternal',
      '孝女':'maternal','孝婿':'maternal'
    };
    /* 唯一身份 prefix · 一個人嘅 case，只能 select 一次。其他 (孝子/孝女/姪/外甥) 可重複（多個仔女/姪輩）*/
    const UNIQUE_PREFIXES = new Set(['妻','夫']);
    const LINEAGE_TIER2 = {
      paternal: ['姪','姪女','孫男','孫女','姪孫','姪孫女','姪曾孫','姪曾孫女','曾孫男','曾孫女','玄孫男','玄孫女'],
      maternal: ['外甥','外甥女','外孫男','外孫女','外甥孫','外甥孫女','外曾孫男','外曾孫女']
    };

    const PREFIX_RANK = {
      '妻':1,'夫':1,'孝男':2,'孝子':2,'孝女':3,'孝媳':4,'孝婿':5,
      '胞兄':6,'胞弟':6,'胞姊':6,'胞妹':6,
      '孫男':10,'孝孫':10,'孫女':11,'孝孫女':11,
      '外孫男':12,'孝外孫':12,'外孫女':13,'孝外孫女':13,
      '姪':14,'姪女':15,'外甥':16,'外甥女':17,
      '表兄':18,'表弟':18,'表姊':19,'表妹':19,
      '曾孫男':20,'曾孫女':21,'外曾孫男':22,'外曾孫女':23,
      '姪孫':24,'姪孫女':25,'外甥孫':26,'外甥孫女':27,
      '表姪':28,'表姪女':29,'姪曾孫':30,'姪曾孫女':31,
      '玄孫男':40,'玄孫女':41,'':99
    };

    const PREFIX_RANK_OPTIONS = {
      '孝子':['長子','次子','三子','四子','五子','六子'],
      '孝男':['長子','次子','三子','四子','五子','六子'],
      '孝女':['長女','次女','三女','四女','五女'],
      '孝媳':['長媳','次媳','三媳','四媳'],
      '孝婿':['長婿','次婿','三婿'],
      '孫男':['長孫','次孫','三孫','四孫','五孫'],
      '孫女':['長孫女','次孫女','三孫女','四孫女'],
      '外孫男':['長外孫','次外孫','三外孫'],
      '外孫女':['長外孫女','次外孫女'],
      '孝孫':['長孫','次孫','三孫','四孫'],
      '孝孫女':['長孫女','次孫女','三孫女'],
      '孝外孫':['長外孫','次外孫'],
      '孝外孫女':['長外孫女','次外孫女'],
      '曾孫男':['長曾孫','次曾孫','三曾孫'],
      '曾孫女':['長曾孫女','次曾孫女'],
      '外曾孫男':['長外曾孫','次外曾孫'],
      '外曾孫女':['長外曾孫女'],
      '玄孫男':['長玄孫'],
      '玄孫女':['長玄孫女'],
      '姪':['長姪','次姪','三姪','四姪','五姪'],
      '姪女':['長姪女','次姪女','三姪女','四姪女'],
      '姪孫':['長姪孫','次姪孫','三姪孫'],
      '姪孫女':['長姪孫女','次姪孫女'],
      '姪曾孫':['長姪曾孫'],
      '姪曾孫女':['長姪曾孫女'],
      '外甥':['長外甥','次外甥','三外甥'],
      '外甥女':['長外甥女','次外甥女'],
      '外甥孫':['長外甥孫','次外甥孫'],
      '外甥孫女':['長外甥孫女'],
      '表兄':['長表兄','二表兄','三表兄'],
      '表弟':['長表弟','二表弟','三表弟','四表弟'],
      '表姊':['長表姊','二表姊','三表姊'],
      '表妹':['長表妹','二表妹','三表妹','四表妹'],
      '表姪':['長表姪','二表姪'],
      '表姪女':['長表姪女'],
      '胞兄':['長兄','二兄','三兄'],
      '胞弟':['長弟','二弟','三弟','四弟','五弟'],
      '胞姊':['長姊','二姊','三姊'],
      '胞妹':['長妹','二妹','三妹','四妹']
    };

    let activeReligion = 'universal';
    let activeWish = '永遠懷念';

    /* ─────── Helpers ─────── */
    function getDeceasedGender() {
      const r = relSelect ? relSelect.value : '';
      if (!r) return null;
      const m = REL[r];
      if (!m) return null;
      const sf = m.sf || '';
      if (/靈鑒|靈右/.test(sf)) return 'f';
      if (sf.includes('女士') || sf.includes('姊妹')) return 'f';
      if (/冥鑒/.test(sf)) return 'm';
      if (sf.includes('先生') || sf.includes('弟兄')) return 'm';
      if (/千古/.test(sf)) return 'm';
      return null;
    }

    function getPrefixTierForRel(rel, prefix) {
      const arr = VALID_SENDERS[rel];
      if (!arr) return 99;
      const f = arr.find(o => o.p === prefix);
      return f ? f.t : 99;
    }

    function getValidPrefixesForRel(rel) {
      const arr = VALID_SENDERS[rel];
      if (!arr) return null;
      return arr.map(o => o.p);
    }

    function getFirstSenderPrefix() {
      const first = block.querySelector('.fn-sender-row [data-fn-sender-prefix]');
      return first ? first.value : '';
    }

    function getAllowedTier2Set(excludeSelect) {
      const lineages = new Set();
      block.querySelectorAll('[data-fn-sender-prefix]').forEach(s => {
        if (s === excludeSelect) return; /* exclude 當前 row 自己 · 防止 lineage filter 拒絕自己 */
        const v = s.value;
        if (v && TIER1_LINEAGE[v]) lineages.add(TIER1_LINEAGE[v]);
      });
      if (lineages.size === 0) return null;
      const allowed = new Set();
      lineages.forEach(l => (LINEAGE_TIER2[l] || []).forEach(p => allowed.add(p)));
      return allowed;
    }

    /* ─────── Wish filter (gender + religion) ─────── */
    function filterWishChips() {
      const gender = getDeceasedGender();
      let firstVisible = null;
      wishChips.forEach(chip => {
        const cg = chip.dataset.fnGender || 'all';
        const cr = chip.dataset.fnRel || 'universal';
        const passReligion = (cr === activeReligion);
        const passGender = (cg === 'all' || !gender || cg === gender);
        const show = passReligion && passGender;
        if (show) { chip.removeAttribute('hidden'); if (!firstVisible) firstVisible = chip; }
        else { chip.setAttribute('hidden', ''); }
      });
      const sel = block.querySelector('.fn-wish-chip.selected');
      if ((!sel || sel.hasAttribute('hidden')) && firstVisible) {
        wishChips.forEach(c => c.classList.remove('selected'));
        firstVisible.classList.add('selected');
        activeWish = firstVisible.dataset.fnWish;
        if (wishInput) wishInput.value = activeWish;
        showMeaning(firstVisible);
        updatePreview();
      }
    }

    /* ─────── Meaning hover ─────── */
    function showMeaning(chip) {
      if (!meaningBox) return;
      const w = chip.dataset.fnWish;
      const m = chip.dataset.fnMeaning || '';
      meaningBox.classList.remove('is-empty');
      meaningBox.innerHTML = '<strong>' + w + '</strong> · ' + m;
    }
    function clearMeaning() {
      if (!meaningBox) return;
      const sel = block.querySelector('.fn-wish-chip.selected');
      if (sel) showMeaning(sel);
      else { meaningBox.classList.add('is-empty'); meaningBox.innerHTML = '<span class="fn-meaning-empty">Hover 任何輓詞 chip · 意思即時顯示喺呢度</span>'; }
    }

    /* ─────── Sender row · prefix filter (tier-progression + lineage) ─────── */
    function filterPrefixOptions(selectEl) {
      const rel = relSelect ? relSelect.value : '';
      const valid = getValidPrefixesForRel(rel);
      const opts = selectEl.querySelectorAll('option, optgroup');
      if (!valid) { opts.forEach(o => o.removeAttribute('hidden')); return; }

      const allRows = [...block.querySelectorAll('[data-fn-sender-prefix]')];
      const myIndex = allRows.indexOf(selectEl);
      const isFirst = myIndex === 0;
      const allowedTier2 = isFirst ? null : getAllowedTier2Set(selectEl);

      let maxOtherTier = 0;
      allRows.forEach((row, idx) => {
        if (idx === myIndex || !row.value) return;
        const t = getPrefixTierForRel(rel, row.value);
        if (t < 99 && t > maxOtherTier) maxOtherTier = t;
      });
      const minAllowed = 1;
      const maxAllowed = isFirst ? 1 : Math.max(2, maxOtherTier + 1);

      /* 收集其他 row 已用嘅 unique prefix · 用嚟 hide 重複 select */
      const usedUnique = new Set();
      allRows.forEach((row, idx) => {
        if (idx === myIndex) return;
        if (row.value && UNIQUE_PREFIXES.has(row.value)) usedUnique.add(row.value);
      });

      opts.forEach(o => {
        if (o.tagName === 'OPTGROUP') { o.removeAttribute('hidden'); return; }
        const v = o.value;
        let show = (v === '' || valid.includes(v));
        if (show && v !== '') {
          const tier = getPrefixTierForRel(rel, v);
          if (tier < minAllowed || tier > maxAllowed) show = false;
          else if (!isFirst && tier >= 2 && allowedTier2 && !allowedTier2.has(v)) show = false;
          /* Unique prefix 已被其他 row 選咗 → hide */
          else if (usedUnique.has(v)) show = false;
        }
        if (show) o.removeAttribute('hidden');
        else o.setAttribute('hidden', '');
      });
      selectEl.querySelectorAll('optgroup').forEach(og => {
        const visible = [...og.querySelectorAll('option')].filter(o => !o.hasAttribute('hidden'));
        if (visible.length === 0) og.setAttribute('hidden', ''); else og.removeAttribute('hidden');
      });
      if (selectEl.value) {
        const tier = getPrefixTierForRel(rel, selectEl.value);
        let stillValid = valid.includes(selectEl.value) && tier >= minAllowed && tier <= maxAllowed;
        if (stillValid && !isFirst && tier >= 2 && allowedTier2) stillValid = allowedTier2.has(selectEl.value);
        /* 如果其他 row 已選咗 same unique prefix，呢個 row reset */
        if (stillValid && usedUnique.has(selectEl.value)) stillValid = false;
        if (!stillValid) selectEl.value = '';
      }
    }

    function refilterAllSenders() {
      block.querySelectorAll('[data-fn-sender-prefix]').forEach(filterPrefixOptions);
    }

    function onPrefixChange(selectEl) {
      const row = selectEl.closest('.fn-sender-row');
      if (!row) return;
      const rankSel = row.querySelector('[data-fn-sender-rank]');
      if (!rankSel) return;
      const prefix = selectEl.value;
      const opts = PREFIX_RANK_OPTIONS[prefix] || [];
      rankSel.innerHTML = '<option value="">（不指定排行）</option>';
      opts.forEach(r => {
        const o = document.createElement('option');
        o.value = r; o.textContent = r;
        rankSel.appendChild(o);
      });
      rankSel.disabled = opts.length === 0;
      rankSel.value = '';
    }

    /* ─────── Relationship change ─────── */
    function onRelChange() {
      const r = relSelect ? relSelect.value : '';
      refilterAllSenders();
      if (!r) { filterWishChips(); updatePreview(); return; }
      const m = REL[r];
      if (!m) { filterWishChips(); updatePreview(); return; }
      const firstSender = block.querySelector('.fn-sender-row [data-fn-sender-prefix]');
      if (firstSender && !firstSender.dataset.userTouched) {
        const valid = VALID_SENDERS[r] || [];
        const validPrefixes = valid.map(o => o.p);
        const tier1Prefixes = valid.filter(o => o.t <= 1).map(o => o.p);
        if (m.spf && validPrefixes.includes(m.spf)) firstSender.value = m.spf;
        else if (tier1Prefixes.length > 0) firstSender.value = tier1Prefixes[0];
        onPrefixChange(firstSender);
      }
      if (suffixSelect && m.ss) {
        suffixSelect.value = m.ss;
        if (suffixInput) suffixInput.value = m.ss;
        if (previewSuffix && !isDirty(previewSuffix)) previewSuffix.textContent = m.ss;
      }
      refilterAllSenders();
      filterWishChips();
      updatePreview();
    }

    /* ─────── Add / remove sender row ─────── */
    function addSender(prefix) {
      const tpl = block.querySelector('.fn-sender-row');
      if (!tpl) return;
      const row = tpl.cloneNode(true);
      row.dataset.sender = '';

      const newPrefix = row.querySelector('[data-fn-sender-prefix]');
      const newRank = row.querySelector('[data-fn-sender-rank]');
      const newName = row.querySelector('[data-fn-sender-name]');

      /* Clean prefix select · 移除 揀關係 placeholder · 清除所有 stale hidden 屬性 · reset value */
      if (newPrefix) {
        [...newPrefix.querySelectorAll('option')].forEach(o => {
          if (o.textContent.includes('揀關係即自動填')) o.remove();
        });
        [...newPrefix.querySelectorAll('option, optgroup')].forEach(o => o.removeAttribute('hidden'));
        newPrefix.value = '';
        delete newPrefix.dataset.userTouched;
      }
      if (newRank) {
        newRank.innerHTML = '<option value="">（不指定排行）</option>';
        newRank.disabled = true;
        newRank.value = '';
      }
      if (newName) newName.value = '';

      sendersWrap.appendChild(row);
      hookSenderRow(row);
      filterPrefixOptions(newPrefix);

      if (prefix && newPrefix) {
        newPrefix.value = prefix;
        onPrefixChange(newPrefix);
      }
      updatePreview();
    }

    function removeSender(btn) {
      const rows = block.querySelectorAll('.fn-sender-row');
      if (rows.length <= 1) {
        /* Last row: just clear values */
        const row = rows[0];
        row.querySelector('[data-fn-sender-prefix]').value = '';
        const rs = row.querySelector('[data-fn-sender-rank]');
        rs.innerHTML = '<option value="">（不指定排行）</option>';
        rs.disabled = true;
        row.querySelector('[data-fn-sender-name]').value = '';
        row.querySelector('[data-fn-sender-prefix]').dataset.userTouched = '';
      } else {
        btn.closest('.fn-sender-row').remove();
      }
      refilterAllSenders();
      updatePreview();
    }

    function hookSenderRow(row) {
      const prefixSel = row.querySelector('[data-fn-sender-prefix]');
      const rankSel = row.querySelector('[data-fn-sender-rank]');
      const nameInp = row.querySelector('[data-fn-sender-name]');
      const rmBtn = row.querySelector('[data-fn-sender-rm]');
      if (prefixSel) prefixSel.addEventListener('change', () => {
        prefixSel.dataset.userTouched = '1';
        onPrefixChange(prefixSel);
        refilterAllSenders();
        updatePreview();
      });
      if (rankSel) rankSel.addEventListener('change', updatePreview);
      if (nameInp) nameInp.addEventListener('input', updatePreview);
      if (rmBtn) rmBtn.addEventListener('click', () => removeSender(rmBtn));
    }

    /* ─────── Live preview ─────── */
    function updatePreview() {
      const r = relSelect ? relSelect.value : '';
      const decName = decNameInput ? (decNameInput.value.trim() || '先人名稱') : '先人名稱';
      const m = r ? REL[r] : null;

      let topText;
      if (m) topText = (m.pf ? m.pf + ' ' : '') + decName + ' ' + (m.sf || '');
      else topText = decName + ' 千古';
      if (previewTop && !isDirty(previewTop)) previewTop.textContent = topText;

      const wish = (wishInput && wishInput.value) ? wishInput.value : activeWish;
      if (previewMid && !isDirty(previewMid)) previewMid.textContent = wish;

      const suffix = suffixInput ? suffixInput.value : '敬輓';
      if (previewSuffix && !isDirty(previewSuffix)) previewSuffix.textContent = suffix;

      /* 下款 multi-sender · sort by tier + rank · insert 率 once */
      const senders = [];
      block.querySelectorAll('.fn-sender-row').forEach(row => {
        const basePfx = row.querySelector('[data-fn-sender-prefix]').value || '';
        const rankSel = row.querySelector('[data-fn-sender-rank]');
        const rankStr = rankSel ? (rankSel.value || '') : '';
        const nm = row.querySelector('[data-fn-sender-name]').value.trim() || '';
        if (nm) {
          const tier = getPrefixTierForRel(r, basePfx);
          const sortRank = PREFIX_RANK[basePfx] !== undefined ? PREFIX_RANK[basePfx] : 99;
          const fullPfx = basePfx + (rankStr || '');
          senders.push({ pfx: fullPfx, nm, tier, rank: sortRank });
        }
      });
      senders.sort((a, b) => a.tier - b.tier || a.rank - b.rank);

      if (!previewBot) return;
      if (isDirty(previewBot)) {
        /* Customer manually edited 下款 · sync hidden inputs and skip rebuild */
        if (senderEncodedInp) senderEncodedInp.value = previewBot.textContent.trim();
        syncPreviewToHidden();
        return;
      }
      previewBot.innerHTML = '';
      if (senders.length === 0) {
        const div = document.createElement('div');
        div.className = 'fn-pb-tier-1';
        div.textContent = '送花人名稱';
        previewBot.appendChild(div);
        if (senderEncodedInp) senderEncodedInp.value = '';
        return;
      }

      const primaryTier = senders[0].tier;
      const anyPrefix = senders.some(s => s.pfx);
      const list = document.createElement('div');
      list.className = 'fn-pb-list';
      let shuaiInserted = false;
      const encodedLines = [];
      const circles = ['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫'];
      let lineNum = 0;
      senders.forEach(s => {
        if (s.tier > primaryTier && !shuaiInserted) {
          const sh = document.createElement('div');
          sh.className = 'fn-pb-shuai';
          sh.textContent = '率';
          list.appendChild(sh);
          shuaiInserted = true;
          encodedLines.push('「率」');
        }
        const div = document.createElement('div');
        div.className = 'fn-pb-line ' + (s.tier === primaryTier ? 'fn-pb-tier-1' : 'fn-pb-tier-2');
        if (anyPrefix) {
          const ps = document.createElement('span');
          ps.className = 'fn-pb-prefix';
          ps.textContent = s.pfx || '';
          div.appendChild(ps);
        }
        const ns = document.createElement('span');
        ns.className = 'fn-pb-name';
        ns.textContent = s.nm;
        div.appendChild(ns);
        list.appendChild(div);
        const num = circles[lineNum] || ((lineNum + 1) + '.');
        lineNum++;
        encodedLines.push(`${num} ${s.pfx ? s.pfx + ' ' : ''}${s.nm}`);
      });
      previewBot.appendChild(list);

      /* Encode 下款 string for cart line item · 用 newline 分行 + circle 數字 · 後綴單獨 property，唔再混落 sender */
      if (senderEncodedInp) {
        senderEncodedInp.value = encodedLines.join('\n');
      }

      /* Density class · 多 sender 時自動縮字級避免 banner 撐爆 */
      const banner = block.querySelector('.fn-banner');
      if (banner) {
        banner.classList.remove('fn-density-2','fn-density-3','fn-density-4','fn-density-5');
        const totalLines = senders.length + (shuaiInserted ? 1 : 0);
        if (totalLines >= 5) banner.classList.add('fn-density-5');
        else if (totalLines >= 4) banner.classList.add('fn-density-4');
        else if (totalLines >= 3) banner.classList.add('fn-density-3');
        else if (totalLines >= 2) banner.classList.add('fn-density-2');
      }
    }

    /* ─────── Wire events ─────── */
    if (relSelect) relSelect.addEventListener('change', onRelChange);
    if (decNameInput) decNameInput.addEventListener('input', updatePreview);
    if (suffixSelect) suffixSelect.addEventListener('change', () => {
      if (suffixInput) suffixInput.value = suffixSelect.value;
      if (previewSuffix && !isDirty(previewSuffix)) previewSuffix.textContent = suffixSelect.value;
      updatePreview();
    });
    if (senderAddBtn) senderAddBtn.addEventListener('click', () => addSender());
    religionChips.forEach(chip => {
      chip.addEventListener('click', () => {
        religionChips.forEach(c => c.classList.remove('is-selected'));
        chip.classList.add('is-selected');
        activeReligion = chip.dataset.fnReligionChip;
        if (religionInput) religionInput.value = chip.textContent.trim();
        filterWishChips();
      });
    });
    wishChips.forEach(chip => {
      chip.addEventListener('mouseenter', () => showMeaning(chip));
      chip.addEventListener('mouseleave', clearMeaning);
      chip.addEventListener('click', () => {
        wishChips.forEach(c => c.classList.remove('selected'));
        chip.classList.add('selected');
        activeWish = chip.dataset.fnWish;
        if (wishInput) wishInput.value = activeWish;
        showMeaning(chip);
        updatePreview();
      });
    });
    /* Hook the initial sender row */
    block.querySelectorAll('.fn-sender-row').forEach(hookSenderRow);

    /* ─────── Step 4 · Venue selector → auto-fill 殯儀館 zone input ─────── */
    const venueSelect = block.querySelector('[data-fn-venue-select]');
    const venueFloor = block.querySelector('[data-fn-venue-floor]');
    const venueRoom = block.querySelector('[data-fn-venue-room]');
    const venueCustom = block.querySelector('[data-fn-venue-custom]');
    const venueFloorHidden = block.querySelector('[data-fn-venue-floor-hidden]');
    const venueRoomHidden = block.querySelector('[data-fn-venue-room-hidden]');
    const zoneInput = document.querySelector('[data-zone-detect]');

    function updateVenue() {
      if (!venueSelect) return;
      let venue = venueSelect.value;
      if (venue === '__custom__') {
        if (venueCustom) {
          venueCustom.removeAttribute('hidden');
          venue = venueCustom.value.trim();
        }
      } else if (venueCustom) {
        venueCustom.setAttribute('hidden', '');
      }
      const floor = venueFloor ? venueFloor.value.trim() : '';
      const room = venueRoom ? venueRoom.value.trim() : '';
      const parts = [];
      if (venue && venue !== '__custom__') parts.push(venue);
      if (floor) parts.push(floor);
      if (room) parts.push(room);
      const combined = parts.join(' / ');
      if (zoneInput) {
        zoneInput.value = combined;
        zoneInput.dispatchEvent(new Event('input', { bubbles: true }));
        zoneInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (venueFloorHidden) venueFloorHidden.value = floor;
      if (venueRoomHidden) venueRoomHidden.value = room;
    }
    [venueSelect, venueFloor, venueRoom, venueCustom].forEach(el => {
      if (!el) return;
      el.addEventListener('input', updateVenue);
      el.addEventListener('change', updateVenue);
    });

    /* ─────── Auto-capture banner JPEG on Add-to-Cart · attach as line item file ─────── */
    const bannerFileInput = block.querySelector('[data-fn-banner-file]');
    const productForm = block.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');

    async function captureAndAttach() {
      if (!bannerFileInput) return false;
      const banner = block.querySelector('.fn-preview-sticky .fn-banner');
      if (!banner) return false;
      try {
        if (!window.html2canvas) {
          await new Promise((res, rej) => {
            const s = document.createElement('script');
            s.src = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
            s.onload = res; s.onerror = rej;
            document.head.appendChild(s);
          });
        }
        /* β.1 v3 · Dynamic scale for A3 300 DPI print quality + PNG lossless */
        const bannerRect = banner.getBoundingClientRect();
        const renderedWidth = bannerRect.width || 350;
        const targetPxA3_300dpi = 3508;
        const scale = Math.max(3, Math.min(12, targetPxA3_300dpi / renderedWidth));
        const canvas = await html2canvas(banner, {
          backgroundColor: '#ffffff',
          scale: scale,
          useCORS: true,
          logging: false,
          letterRendering: true
        });
        const blob = await new Promise(r => canvas.toBlob(r, 'image/png'));
        if (!blob) return false;
        const decName = decNameInput && decNameInput.value.trim() || '輓聯';
        const ts = Date.now();
        const file = new File([blob], `TFK_輓聯_${decName}_${ts}.png`, { type: 'image/png' });
        const dt = new DataTransfer();
        dt.items.add(file);
        bannerFileInput.files = dt.files;
        return true;
      } catch (e) {
        console.error('[funeral banner capture]', e);
        return false;
      }
    }

    if (productForm && bannerFileInput) {
      /* Capture phase listener · runs FIRST before /cart/add.js global handler */
      productForm.addEventListener('submit', async (e) => {
        if (bannerFileInput.dataset.captured === '1') return; /* already captured this submit */
        e.preventDefault();
        e.stopImmediatePropagation();
        bannerFileInput.dataset.captured = '1';
        await captureAndAttach();
        /* Re-fire submit event so other handlers (Ajax cart/add) pick up the file */
        if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
        else productForm.submit();
      }, true); /* CAPTURE phase */
    }

    /* β.1 v2 · Per-line dirty tracking — any direct edit marks that line dirty */
    editables.forEach(el => {
      el.addEventListener('input', () => {
        markDirty(el);
        /* Add visual indicator class to show this line is locked */
        el.classList.add('fn-pb-line-dirty');
        syncPreviewToHidden();
      });
      /* Block Enter for single-line preview lines */
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') e.preventDefault();
      });
    });

    /* Initial reset clears dirty class too · used when 重置按鈕 撳 */
    function clearDirtyVisual(){ editables.forEach(el => el.classList.remove('fn-pb-line-dirty')); }
    const _origResetToAuto = resetToAuto;
    resetToAuto = function(){ clearDirtyVisual(); _origResetToAuto(); };
    if (resetBtn){
      /* Re-attach with the wrapped fn */
      resetBtn.removeEventListener('click', _origResetToAuto);
      resetBtn.addEventListener('click', resetToAuto);
    }

    /* ─────── Init ─────── */
    filterWishChips();
    refilterAllSenders();
    /* Mark first wish chip as selected by default */
    const firstWish = block.querySelector('.fn-wish-chip:not([hidden])');
    if (firstWish) {
      firstWish.classList.add('selected');
      activeWish = firstWish.dataset.fnWish;
      if (wishInput) wishInput.value = activeWish;
    }
    updatePreview();
    syncPreviewToHidden();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFuneral);
  } else {
    initFuneral();
  }
})();


/* ════════════════════════════════════════════════════════
 * TFK Card Capture · 2026-05-19 v7 · basket + bouquet
 * Basket (.go-card · plain span text) html2canvas-friendly · just capture
 * Bouquet (.od-card-editor · has textarea) · onclone swaps textarea → mirror span (same pattern as basket spans · reliable rendering)
 * Funeral has own handler · skip
 * ════════════════════════════════════════════════════════ */
(function tfkCardCapture(){
  'use strict';

  function findActiveCard(form){
    if (form.querySelector('[data-fn-banner-file]')) return null; // funeral · own handler

    // Basket · grand-opening (3 card styles · plain span text)
    const goCard = form.querySelector('.go-card.is-visible');
    if (goCard) {
      const styleInput = form.querySelector('[data-go-card-input]');
      const styleName = (styleInput && styleInput.value) || 'Card';
      return { type: 'basket', el: goCard, label: '賀卡預覽圖 Card JPEG', filename: 'TFK_賀卡_' + styleName };
    }

    // Bouquet · od-card-editor (textarea body · needs onclone mirror swap)
    const odCard = form.querySelector('.od-card-editor');
    if (odCard && odCard.offsetParent !== null) {
      const body = odCard.querySelector('.od-card-body');
      const recipInput = form.querySelector('.od-recipient-input, [name*="收花人名稱"], [name*="Recipient"]');
      const sigInput = form.querySelector('.od-card-sig-input, [name*="署名"], [name*="Signature"]');
      const hasContent = (body && body.value.trim())
                      || (recipInput && recipInput.value && recipInput.value.trim())
                      || (sigInput && sigInput.value && sigInput.value.trim());
      if (!hasContent) return null;
      return { type: 'bouquet', el: odCard, label: '心意卡預覽圖 Message Card JPEG', filename: 'TFK_心意卡' };
    }

    return null;
  }

  function initCapture(){
    const form = document.querySelector('form[action*="/cart/add"][data-pdp-form]');
    if (!form || form.dataset.cardCaptureBound === '1') return;
    if (form.querySelector('[data-fn-banner-file]')) return; // funeral
    if (!form.querySelector('.go-card.is-visible') && !form.querySelector('.od-card-editor')) return;
    form.dataset.cardCaptureBound = '1';

    let fileInput = form.querySelector('[data-card-preview-file]');
    if (!fileInput) {
      fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'image/png';
      fileInput.hidden = true;
      fileInput.setAttribute('data-card-preview-file', '');
      form.appendChild(fileInput);
    }

    async function captureAndAttach(){
      const active = findActiveCard(form);
      if (!active) return false;
      try {
        if (!window.html2canvas) {
          await new Promise((res, rej) => {
            const s = document.createElement('script');
            s.src = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
            s.onload = res; s.onerror = rej;
            document.head.appendChild(s);
          });
        }
        if (document.fonts && document.fonts.ready) { await document.fonts.ready; }
        const rect = active.el.getBoundingClientRect();
        const renderedWidth = rect.width || 350;
        const targetPxA3_300dpi = 3508;
        const scale = Math.max(3, Math.min(12, targetPxA3_300dpi / renderedWidth));
        const opts = {
          backgroundColor: '#ffffff',
          scale: scale,
          useCORS: true,
          logging: false,
          letterRendering: true
        };
        // Bouquet · swap textarea → mirror span on cloned DOM + inject capture-only layout CSS
        if (active.type === 'bouquet') {
          opts.onclone = function(clonedDoc, clonedEl){
            try {
              const liveTextarea = active.el.querySelector('textarea.od-card-body');
              const clonedTextarea = clonedEl.querySelector('textarea.od-card-body');
              const clonedMirror = clonedEl.querySelector('.od-card-body-mirror');
              const clonedMirrorText = clonedEl.querySelector('[data-card-body-mirror-text]');
              const val = liveTextarea ? liveTextarea.value : '';
              if (clonedMirrorText) clonedMirrorText.textContent = val;
              if (clonedMirror) clonedMirror.style.display = 'block';
              if (clonedTextarea) clonedTextarea.style.display = 'none';
              /* 2026-05-19 Gary final spec · download PNG only · 4-corner absolute + centered message */
              const captureStyle = clonedDoc.createElement('style');
              captureStyle.textContent = `
                .pdp-b .order-details .od-card-editor {
                  position: relative !important;
                  display: block !important;
                  padding: 0 !important;
                  aspect-ratio: 5/3 !important;
                  min-height: 0 !important;
                  background-image: none !important;
                  background-color: #ece5d4 !important;
                  box-shadow: 0 2px 8px rgba(42, 37, 32, 0.08) !important;
                }
                .pdp-b .order-details .od-card-emboss {
                  position: absolute !important;
                  top: 8px !important;
                  left: 50% !important;
                  transform: translateX(-50%) !important;
                  margin: 0 !important;
                }
                .pdp-b .order-details .od-card-emboss-text {
                  font-size: 10px !important;
                  letter-spacing: 0.25em !important;
                  padding-bottom: 3px !important;
                }
                .pdp-b .order-details .od-card-recipient-display {
                  position: absolute !important;
                  top: 54px !important;
                  left: 14px !important;
                  font-size: 13px !important;
                  margin: 0 !important;
                }
                .pdp-b .order-details .od-card-body-mirror {
                  position: absolute !important;
                  left: 0 !important;
                  right: 0 !important;
                  top: 58% !important;
                  transform: translateY(-50%) !important;
                  width: 100% !important;
                  box-sizing: border-box !important;
                  margin: 0 !important;
                  padding: 0 50px !important;
                  font-size: 0 !important;
                  line-height: 0 !important;
                  text-align: center !important;
                  display: block !important;
                }
                .pdp-b .order-details .od-card-body-mirror [data-card-body-mirror-text] {
                  font-size: 13px !important;
                  line-height: 1.85 !important;
                  text-align: center !important;
                  word-break: keep-all !important;
                  line-break: strict !important;
                  overflow-wrap: normal !important;
                  display: inline-block !important;
                  color: #3a2e2c !important;
                  font-family: var(--zh), 'Cormorant Garamond', serif !important;
                  font-style: italic !important;
                  letter-spacing: 0.04em !important;
                }
                .pdp-b .order-details .od-card-sig-display {
                  position: absolute !important;
                  bottom: 14px !important;
                  right: 14px !important;
                  margin: 0 !important;
                  font-size: 12px !important;
                }
              `;
              clonedDoc.head.appendChild(captureStyle);
            } catch(_) {}
          };
        }
        const canvas = await html2canvas(active.el, opts);
        const blob = await new Promise(r => canvas.toBlob(r, 'image/png'));
        if (!blob) return false;
        const ts = Date.now();
        const file = new File([blob], active.filename + '_' + ts + '.png', { type: 'image/png' });
        const dt = new DataTransfer();
        dt.items.add(file);
        fileInput.name = 'properties[' + active.label + ']';
        fileInput.files = dt.files;
        return true;
      } catch (e) {
        console.error('[card capture]', e);
        return false;
      }
    }

    form.addEventListener('submit', async (e) => {
      if (fileInput.dataset.captured === '1') return;
      if (!findActiveCard(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fileInput.dataset.captured = '1';
      await captureAndAttach();
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCapture);
  else initCapture();
})();


/* ════════════════════════════════════════════════════════
 * TFK Delivery Picker · Phase γ.1 · 2026-05-13
 * Date row (4 chip · 60d custom) + 6 mode 互斥
 * Buffer 3hr 過濾 (只 today) · 加急單 only today AND now ≤ 16:30
 * ════════════════════════════════════════════════════════ */
(function tfkDeliveryPicker(){
  'use strict';
  const BUFFER_MIN = 180;
  const RUSH_MIN = 120;
  const RUSH_CUTOFF_MIN = 16*60 + 30;  // 16:30 (b · cut-off ETA ≤ 18:30 收工)
  const TIER_BOUNDS = {
    'early':      [480, 540],   // 08:00-09:00
    'standard':   [600, 1110],  // 10:00-18:30
    'evening':    [1140, 1260], // 19:00-21:00
    'late-night': [1260, 1440], // 21:00-24:00
  };
  const WEEKDAY_LBL = ['日','一','二','三','四','五','六'];

  function parseTime(s){ const p = s.split(':'); return Number(p[0])*60 + Number(p[1]); }
  function pad2(n){ return String(n).padStart(2,'0'); }
  function minToHHMM(m){ m = ((m % 1440) + 1440) % 1440; const h = Math.floor(m/60), mm = m%60; return pad2(h) + ':' + pad2(mm); }
  /* 12-hour format · 15:00 → "3:00pm" · 9:00 → "9:00am" · 0:00 → "12:00am" */
  function to12h(m){
    m = ((m % 1440) + 1440) % 1440;
    let h = Math.floor(m/60); const mm = m%60;
    const period = h >= 12 ? 'pm' : 'am';
    if (h === 0) h = 12;
    else if (h > 12) h = h - 12;
    return h + ':' + pad2(mm) + period;
  }
  function nowMin(){ const d = new Date(); return d.getHours()*60 + d.getMinutes(); }
  function dateOffset(offset){ const d = new Date(); d.setDate(d.getDate() + offset); return d; }
  function isoDate(d){ return d.getFullYear() + '-' + pad2(d.getMonth()+1) + '-' + pad2(d.getDate()); }
  function shortDate(d){ return (d.getMonth()+1) + '/' + d.getDate() + ' ' + WEEKDAY_LBL[d.getDay()]; }
  function longDate(d){ return d.getFullYear() + '年' + (d.getMonth()+1) + '月' + d.getDate() + '日 · 星期' + WEEKDAY_LBL[d.getDay()]; }

  function init(){
    const root = document.querySelector('[data-tfk-delivery-picker]');
    if (!root) return;

    /* Settings */
    const disabledWeekdays = (root.dataset.tfkDisabledWeekdays || '').split(',').map(s => s.trim()).filter(s => s !== '').map(Number);
    const disabledDates = (root.dataset.tfkDisabledDates || '').split(',').map(s => s.trim()).filter(Boolean);
    const minDays = Number(root.dataset.tfkMinDays || 0);
    const maxFutureDays = Number(root.dataset.tfkMaxFutureDays || 60);

    /* DOM refs */
    const elNow = root.querySelector('[data-tfk-now]');
    const elEarliest = root.querySelector('[data-tfk-earliest]');
    const elRushNow = root.querySelector('[data-tfk-rush-now]');
    const elRushEta = root.querySelector('[data-tfk-rush-eta]');
    const windowBox = root.querySelector('[data-tfk-window-box]');
    const slotBox = root.querySelector('[data-tfk-slot-box]');
    const etaBox = root.querySelector('[data-tfk-eta-box]');
    const rushWarn = root.querySelector('[data-tfk-rush-warn]');
    const rushWarnText = root.querySelector('[data-tfk-rush-warn-text]');
    const inputDate = root.querySelector('[data-tfk-prop-date]');
    const inputDateIso = root.querySelector('[data-tfk-prop-date-iso]');
    const inputMode = root.querySelector('[data-tfk-prop-mode]');
    const inputDetail = root.querySelector('[data-tfk-prop-detail]');
    const inputVariant = root.querySelector('[data-tfk-surcharge-variant]');
    const inputPrice = root.querySelector('[data-tfk-surcharge-price]');
    const summaryMode = root.querySelector('[data-tfk-summary-mode]');
    const summaryDetail = root.querySelector('[data-tfk-summary-detail]');
    const summaryPrice = root.querySelector('[data-tfk-summary-price]');
    const collapsedSum = root.querySelector('[data-tfk-collapsed-summary]');
    const toggleBtn = root.querySelector('[data-tfk-toggle]');
    const bodyEl = root.querySelector('[data-tfk-body]');
    const customBox = root.querySelector('[data-tfk-custom-date-box]');
    const customInput = root.querySelector('[data-tfk-custom-date-input]');
    const customResult = root.querySelector('[data-tfk-custom-date-result]');
    const dateSubEl = root.querySelector('[data-tfk-date-sub]');

    /* State */
    let selectedDate = 'today';   // today / tomorrow / day-after / custom
    let customDateObj = null;     // Date instance when selectedDate === 'custom'

    function getSelectedDateObj(){
      if (selectedDate === 'today') return dateOffset(0);
      if (selectedDate === 'tomorrow') return dateOffset(1);
      if (selectedDate === 'day-after') return dateOffset(2);
      if (selectedDate === 'custom' && customDateObj) return customDateObj;
      return dateOffset(0);
    }
    function isDateToday(){ return selectedDate === 'today'; }

    /* Fill date chip short labels (今日 5/13 三 etc.) */
    function fillDateLabels(){
      ['today','tomorrow','day-after'].forEach((k,i) => {
        const el = root.querySelector('[data-tfk-date-label-' + k + ']');
        if (el) el.textContent = shortDate(dateOffset(i));
      });
      if (customInput) {
        const minDate = dateOffset(Math.max(minDays, 0));
        const maxDate = dateOffset(maxFutureDays);
        customInput.min = isoDate(minDate);
        customInput.max = isoDate(maxDate);
      }
    }

    function isDateDisabled(d){
      const iso = isoDate(d);
      if (disabledDates.includes(iso)) return '已關閉接單';
      if (disabledWeekdays.includes(d.getDay())) return '此星期日子不接單';
      return null;
    }

    /* Buffer + 已過時間 filter (only today) */
    function refreshGates(){
      const m = nowMin();
      const bufferEnd = m + BUFFER_MIN;
      const todayMode = isDateToday();

      /* Tier mode chips · 特早 / 標準 / 晚間 / 特晚 */
      Object.entries(TIER_BOUNDS).forEach(([modeName, bounds]) => {
        const chip = root.querySelector('[data-tfk-mode="' + modeName + '"]');
        if (!chip) return;
        let disable = false;
        if (todayMode) {
          if (bounds[1] <= bufferEnd) disable = true;
        }
        chip.classList.toggle('is-dis', disable);
        if (disable && chip.classList.contains('is-on')) {
          chip.classList.remove('is-on');
          const fb = root.querySelector('.tfk-dt-chip:not(.is-dis)[data-tfk-mode]');
          if (fb) activateMode(fb, false);
        }
      });

      /* 指定 30 min mode chip · disabled if no slot available today */
      const preciseChip = root.querySelector('[data-tfk-mode="precise"]');
      if (preciseChip) {
        let allDisabled = false;
        if (todayMode) {
          const slots = Array.from(root.querySelectorAll('[data-tfk-slot]'));
          allDisabled = slots.every(s => parseTime(s.dataset.tfkSlot.split(/[–-]/)[0]) < bufferEnd);
        }
        preciseChip.classList.toggle('is-dis', allDisabled);
      }

      /* 加急單 chip · only today AND now ≤ 16:30 */
      const rushChip = root.querySelector('[data-tfk-mode="rush"]');
      if (rushChip) {
        let rushOK = todayMode && m <= RUSH_CUTOFF_MIN;
        rushChip.classList.toggle('is-dis', !rushOK);
        if (!rushOK && rushChip.classList.contains('is-on')) {
          rushChip.classList.remove('is-on');
          const fb = root.querySelector('.tfk-dt-chip:not(.is-dis)[data-tfk-mode]');
          if (fb) activateMode(fb, false);
        }
        if (rushWarn) {
          if (todayMode && m > RUSH_CUTOFF_MIN) {
            rushWarn.hidden = false;
            if (rushWarnText) rushWarnText.textContent = '加急單已過 16:30 cut-off · 今日已關閉接單';
          } else if (!todayMode) {
            rushWarn.hidden = false;
            if (rushWarnText) rushWarnText.textContent = '加急單只限今日下單 · 16:30 前';
          } else {
            rushWarn.hidden = true;
          }
        }
      }

      /* Windows */
      root.querySelectorAll('[data-tfk-window]').forEach(w => {
        const parts = w.dataset.tfkWindow.split(/[–-]/);
        const endMin = parseTime(parts[1]);
        const disable = todayMode && endMin <= bufferEnd;
        w.classList.toggle('is-dis', disable);
        if (disable && w.classList.contains('is-on')) {
          w.classList.remove('is-on');
          const fb = root.querySelector('[data-tfk-window]:not(.is-dis)');
          if (fb) fb.classList.add('is-on');
        }
      });

      /* Slots */
      root.querySelectorAll('[data-tfk-slot]').forEach(s => {
        const parts = s.dataset.tfkSlot.split(/[–-]/);
        const startMin = parseTime(parts[0]);
        const disable = todayMode && startMin < bufferEnd;
        s.classList.toggle('is-dis', disable);
        if (disable && s.classList.contains('is-on')) s.classList.remove('is-on');
      });
    }

    function updateSlotGroupMeta(){
      ['morning','noon','afternoon'].forEach(g => {
        const groupEl = root.querySelector('[data-tfk-slot-group="' + g + '"]');
        if (!groupEl) return;
        const slots = groupEl.querySelectorAll('[data-tfk-slot]');
        const total = slots.length;
        const available = Array.from(slots).filter(s => !s.classList.contains('is-dis')).length;
        const meta = root.querySelector('[data-tfk-slot-meta="' + g + '"]');
        if (meta) meta.textContent = total + ' 區間 · ' + available + ' 可揀';
      });
    }

    function updateClock(){
      const m = nowMin();
      const nowStr = to12h(m);
      const earliestStr = to12h(m + BUFFER_MIN);
      const rushEtaStr = to12h(m + RUSH_MIN);
      if (elNow) elNow.textContent = nowStr;
      if (elEarliest) elEarliest.textContent = earliestStr;
      if (elRushNow) elRushNow.textContent = nowStr;
      if (elRushEta) elRushEta.textContent = rushEtaStr;
      refreshGates();
      updateSlotGroupMeta();
      syncState();
    }

    function syncState(){
      /* Date display */
      const dObj = getSelectedDateObj();
      const dLong = longDate(dObj);
      if (dateSubEl) dateSubEl.textContent = dLong;
      if (inputDate) inputDate.value = dLong;
      if (inputDateIso) inputDateIso.value = isoDate(dObj);

      const active = root.querySelector('.tfk-dt-chip.is-on[data-tfk-mode]');
      if (!active) {
        /* Try fallback */
        const fb = root.querySelector('.tfk-dt-chip:not(.is-dis)[data-tfk-mode]');
        if (fb) { fb.classList.add('is-on'); return syncState(); }
        return;
      }
      const mode = active.dataset.tfkMode;
      const tierLabel = active.dataset.tfkTierLabel || '';
      const variant = active.dataset.tfkVariant || '';
      const price = active.dataset.tfkPrice || '0';

      if (inputMode) inputMode.value = tierLabel;
      if (inputVariant) inputVariant.value = variant;
      if (inputPrice) inputPrice.value = price;

      let detail = '';
      if (mode === 'standard') {
        const w = root.querySelector('.tfk-dt-window.is-on');
        detail = w ? (w.dataset.tfkWindowLabel || w.dataset.tfkWindow) : '（請揀 window）';
      } else if (mode === 'precise') {
        const s = root.querySelector('.tfk-dt-slot.is-on');
        detail = s ? (s.dataset.tfkSlotLabel || s.dataset.tfkSlot) : '（請揀 slot）';
      } else if (mode === 'rush') {
        const rushEtaStr = elRushEta ? elRushEta.textContent : '';
        detail = '由 checkout 起 2hr · 約 ' + rushEtaStr;
      } else {
        detail = '範圍內隨機派送';
      }
      if (inputDetail) inputDetail.value = detail;

      if (summaryMode) summaryMode.textContent = tierLabel;
      if (summaryDetail) summaryDetail.textContent = detail || '—';
      if (summaryPrice) {
        const p = Number(price || 0);
        summaryPrice.textContent = p > 0 ? '+$' + p : '免費';
      }
      if (collapsedSum) {
        const p = Number(price || 0);
        const priceStr = p > 0 ? '+$' + p : '免費';
        const tierShort = (tierLabel.split(' ')[0]) || tierLabel;
        const dateShort = (selectedDate === 'today') ? '今日'
                       : (selectedDate === 'tomorrow') ? '明日'
                       : (selectedDate === 'day-after') ? '後日'
                       : shortDate(dObj);
        const detailShort = detail || '';
        collapsedSum.textContent = dateShort + ' · ' + tierShort + (detailShort ? ' · ' + detailShort : '') + ' · ' + priceStr;
      }
    }

    function activateMode(chip, doSync){
      if (chip.classList.contains('is-dis')) return;
      root.querySelectorAll('.tfk-dt-chip[data-tfk-mode]').forEach(c => c.classList.remove('is-on'));
      chip.classList.add('is-on');
      const mode = chip.dataset.tfkMode;
      if (windowBox) windowBox.hidden = (mode !== 'standard');
      if (slotBox) slotBox.hidden = (mode !== 'precise');
      if (etaBox) etaBox.hidden = (mode !== 'rush');
      if (doSync !== false) syncState();
    }

    function activateWindow(w){
      if (w.classList.contains('is-dis')) return;
      root.querySelectorAll('[data-tfk-window]').forEach(x => x.classList.remove('is-on'));
      w.classList.add('is-on');
      syncState();
    }

    function activateSlot(s){
      if (s.classList.contains('is-dis')) return;
      root.querySelectorAll('[data-tfk-slot]').forEach(x => x.classList.remove('is-on'));
      s.classList.add('is-on');
      syncState();
    }

    function activateDate(chip){
      const key = chip.dataset.tfkDate;
      if (!key) return;
      root.querySelectorAll('[data-tfk-date]').forEach(d => d.classList.remove('is-on'));
      chip.classList.add('is-on');
      selectedDate = key;
      if (customBox) customBox.hidden = (key !== 'custom');
      if (key === 'custom') {
        if (!customDateObj) {
          customDateObj = dateOffset(Math.max(minDays, 3));
          if (customInput) customInput.value = isoDate(customDateObj);
        }
        validateCustomDate();
      }
      refreshGates();
      syncState();
    }

    function validateCustomDate(){
      if (!customInput || !customInput.value) {
        if (customResult) customResult.textContent = '';
        return false;
      }
      const parts = customInput.value.split('-').map(Number);
      const d = new Date(parts[0], parts[1]-1, parts[2]);
      const today = new Date(); today.setHours(0,0,0,0);
      const diff = Math.round((d - today) / 86400000);
      if (diff < minDays) {
        if (customResult) customResult.innerHTML = '<span style="color:#A04F4F">⚠ 至少 ' + minDays + ' 日後</span>';
        return false;
      }
      if (diff > maxFutureDays) {
        if (customResult) customResult.innerHTML = '<span style="color:#A04F4F">⚠ 最遠 ' + maxFutureDays + ' 日內</span>';
        return false;
      }
      const blockMsg = isDateDisabled(d);
      if (blockMsg) {
        if (customResult) customResult.innerHTML = '<span style="color:#A04F4F">⚠ ' + blockMsg + '</span>';
        return false;
      }
      customDateObj = d;
      if (customResult) customResult.textContent = '✓ ' + longDate(d);
      return true;
    }

    /* Toggle handler */
    if (toggleBtn && bodyEl) {
      toggleBtn.addEventListener('click', () => {
        const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        bodyEl.hidden = expanded;
      });
    }

    /* Click delegation */
    root.addEventListener('click', e => {
      const dateChip = e.target.closest('[data-tfk-date]');
      if (dateChip) { activateDate(dateChip); return; }
      const modeChip = e.target.closest('.tfk-dt-chip[data-tfk-mode]');
      if (modeChip) { activateMode(modeChip); return; }
      const win = e.target.closest('[data-tfk-window]');
      if (win) { activateWindow(win); return; }
      const slot = e.target.closest('[data-tfk-slot]');
      if (slot) { activateSlot(slot); return; }
    });

    if (customInput) {
      customInput.addEventListener('change', () => {
        if (validateCustomDate()) {
          refreshGates();
          syncState();
        }
      });
    }

    /* Init */
    fillDateLabels();
    updateClock();
    setInterval(updateClock, 30000);
    syncState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
